<template>
  <div class="content-box" :class="{'m': isM }" >
    <img :src="getPic()" width="100%" alt="" class="bg_img">
<!--    <div class="content">-->
<!--      <div class="head">四川繁羽开天科技有限公司游戏隐私政策</div>-->
<!--      <div class="section">-->
<!--        <div class="line">导言</div>-->
<!--        <div class="line">-->
<!--          <span>“四川繁羽开天科技有限公司游戏”(以下亦称“我们的产品与/或服务”)指由四川繁羽开天科技有限公司传媒有限公司及/或其关联公司(以下亦称“四川繁羽开天科技有限公司”、“我们”)提供的网络游戏类产品与/或服务。我们深知个人信息对您的重要性，因此我们非常重视保护您的隐私和个人信息。我们希望通过本《四川繁羽开天科技有限公司游戏隐私政策》(以下亦称“本政策”)向您清晰地介绍您在使用我们的产品与/或服务时，我们如何处理您的个人信息，以及我们为您提供的管理、保护这些信息的方式。</span>-->
<!--          <span class="boldT">涉及本政策中与您的权益(可能)存在重大关系的条款以及涉及敏感个人信息的处理，我们已经以字体加粗、下划线或其他合理方式提示您重点阅读。您可以拒绝向我们提供这些个人敏感信息，但是拒绝提供这些信息会影响用户使用本产品和/或服务项下的特定功能。</span>-->
<!--        </div>-->
<!--        <div class="boldT">您同意我们为遵守法律法规的要求及/或为实现产品功能和服务需要，将依据本隐私政策的约定对您的相关个人信息进行处理。但这并不代表只要您开始使用我们的产品与/或服务，我们将处理本政策中涉及的全部个人信息。仅当您使用特定功能及/或为遵守法律法规的要求时，我们会根据“最小必要"原则，为实现明确合理的目的，处理您的相关个人信息。</div>-->
<!--      </div>-->
<!--      <div class="section">-->
<!--        <div class="boldT line">本《四川繁羽开天科技有限公司游戏隐私政策》将帮助您了解以下内容</div>-->
<!--        <div class="line">一、我们如何收集和使用您的个人信息</div>-->
<!--        <div class="line">二、我们如何使用Cookie和同类技术</div>-->
<!--        <div class="line">三、我们如何共享、转让、公开披露您的个人信息</div>-->
<!--        <div class="line">四、您对个人信息享有的控制权</div>-->
<!--        <div class="line">五、我们如何存储和保护您的个人信息</div>-->
<!--        <div class="line">六、未成年人保护</div>-->
<!--        <div class="line">七、本政策的更新</div>-->
<!--        <div class="line">八、如何联系我们</div>-->
<!--        <div class="line">九、其他</div>-->
<!--      </div>-->
<!--      <div class="section">-->
<!--        <div class="boldT line">一、我们如何收集和使用您的个人信息</div>-->
<!--        <div class="line">-->
<!--          <span>相机、相册/存储、麦克风等系统权限均不会默认开启，只有经过您单独同意后，才会在为实现特定功能/服务时访问</span>-->
<!--          <span class="boldT">即使经过您的授权，可以访问您的相应权限，我们仅会在您的授权范围内进行访问,并获取相应信息(如涉及):且您可随时撤回授权，在您撤回授权后，我们将停止访问相应权限，也将无法再为您提供与之对应的某些服务，但不影响您享受我们提供的其他服务。查看</span>-->
<!--          <a href="https://kl3g96a53c.feishu.cn/docx/WUDLdptKUofm0OxNaQccLZXvnoc">四川繁羽开天科技有限公司游戏应用权限使用情况说明</a>-->
<!--          <span>。</span>-->
<!--        </div>-->
<!--        <div class="boldT">我们主要通过以下途径收集您在使用我们的产品与/或服务时涉及的个人信息:</div>-->
<!--        <div class="line">1.根据业务需要您主动提供的信息，例如:注册账号时提供的手机号码。</div>-->
<!--        <div class="line">2.我们收集、记录、汇总的信息，例如:您的设备信息、游戏日志信息。</div>-->
<!--        <div class="line">3.我们从第三方间接获取的您的信息，例如:账号授权登录时，第三方平台提供的您的昵称和头像。</div>-->
<!--        <div class="boldT"></div>-->
<!--        <div class="boldT line">通常情况下，我们会出于以下功能/场景的实现，收集和使用您的个人信息或申请相关权限:</div>-->
<!--        <div class="boldT line">(一)账号注册与登录</div>-->
<!--        <div class="line">-->
<!--          <span>注册/登录:当您注册、登录我们的产品与/或服务时，为了帮助您顺利完成注册/登录流程,您需要向我们提供您的</span>-->
<!--          <span class="boldT">手机号码、四川繁羽开天科技有限公司游戏账号登录密码信息。收集您的手机号码是为了满足相关法律法规的网络实名制要求如您拒绝提供手机号码进行核验，将导致注册/登录失败，您将无法使用我们的产品与/或服务。</span>-->
<!--          <span>若您采用邮箱方式登录，则需要向我们提供您的</span>-->
<!--          <span class="boldT">电子邮箱信息、四川繁羽开天科技有限公司游戏账号登录密码信息。</span>-->
<!--        </div>-->
<!--        <div class="line">-->
<!--          <span>授权登录:您使用第三方平台(例如:QQ/微信等账号)的账号授权登录时，您授权我们获取</span>-->
<!--          <span class="boldT">该第三方账号下的相关信息(包括昵称、头像，具体以您的授权范围为准)，</span>-->
<!--          <span>用于与四川繁羽开天科技有限公司游戏账号绑定、网络资料信息的完孝</span>-->
<!--        </div>-->
<!--        <div class="line">手机号码绑定解除:信通院提供的“码号公共服务平台”对符合条件的手机号码提供一键解绑服务，我们在收到信通院的指令后，将直接解除该手机号码与对应四川繁羽开天科技有限公司游戏账号的绑定关系，并删除或匿名化处理该手机号码信息。</div>-->
<!--        <div class="line">-->
<!--          <span>资料维护:根据游戏的具体情况，您可自主选择填写您的</span>-->
<!--          <span class="boldT">昵称、头像、性别、出生日期、地区、个性签名等部分或全部信息，</span>-->
<!--          <span>以实现更好的社交体验。</span>-->
<!--          <span class="boldT">如您未填写，不影响您使用我们产品与/或服务的其他功能。</span>-->
<!--          <span>您在上传/更换头像时，我们可能会请求您的</span>-->
<!--          <span class="boldT">相机、相册/存储权限，</span>-->
<!--          <span>并收集您上传/更换的</span>-->
<!--          <span class="boldT">图片信息。</span>-->
<!--        </div>-->
<!--        <div class="line">-->
<!--          <span>账号信息公开:您的</span>-->
<!--          <span class="boldT">个人资料、获赞、皮肤等部分或全部信息</span>-->
<!--          <span>可能会在您的个人/角色空间页公开展示。</span>-->
<!--        </div>-->
<!--        <div class="boldT line">(二)实名认证</div>-->
<!--        <div class="line">-->
<!--          <span>为满足相关法律法规和主管部门关于游戏实名认证及防止未成年人沉迷网络游戏的要求，您需进行实名认证以继续使用我们的产品与/或服务。我们会在获得您同意或您主动提供的情况下收集您的</span>-->
<!--          <span class="boldT">实名身份信息(包括姓名、身份证号)，并将其提交至国家新闻出版署网络游戏防沉迷实名验证系统进行真实身份验证，拒绝提供实名身份信息可能会导致您无法使用我们的产品与/或服务。如根据实名身份信息我们判断您为未成年人，依照相关法律法规及主管部门要求，您的游戏时间、游戏时长、付费服务等将会受到相关限制。</span>-->
<!--        </div>-->
<!--        <div class="boldT line">(三)游戏充值、兑换</div>-->
<!--        <div class="line">1.充值</div>-->
<!--        <div class="line">1)下单</div>-->
<!--        <div class="line">-->
<!--          <span>当您对游戏金币等虚拟货币或其他商品/服务进行下单时，我们需要收集如下部分或全部的个人信息，包括:您的</span>-->
<!--          <span class="boldT">交易信息、订单编号、下单时间、订单金额等，</span>-->
<!--          <span>我们收集这些信息是为了帮助您顺利完成前述购买、保障您的交易安全、查询订单信息、提供客户服务等。同时，为便于您了解、查询订单信息并对订单信息进行管理，我们会在我们的产品与/或服务中向您展示您支付成功的订单信息。</span>-->
<!--        </div>-->
<!--        <div class="line">2）支付</div>-->
<!--        <div class="line">-->
<!--          <span>为完成订单支付、保障交易安全，我们需要收集您的</span>-->
<!--          <span class="boldT">交易金额、下单时间、订单商户、订单编号、支付方式、支付账号、支付状态信息，</span>-->
<!--          <span>并通过安全方式与支付机构(如微信、支付宝)进行前述部分或全部信息的共享。</span>-->
<!--        </div>-->
<!--        <div class="line">-->
<!--          <span>同时，若您使用我们产品与/或服务中的人脸/指纹支付功能的，您需要在您的本地设备端提前录入人脸或指纹信息，并在使用服务时在您的设备上完成信息验证。</span>-->
<!--          <span class="boldT">我们需要使用您的面容ID/触控ID权限(生物识别身份验证权限)以便接收验证结果，但我们并不收集您的人脸或指纹信息。</span>-->
<!--          <span>若您不开启此权限，您将无法使用前述服务，但不影响您选择其他支付方式。</span>-->
<!--        </div>-->
<!--        <div class="line">3）兑换</div>-->
<!--        <div class="line">-->
<!--          <span>当您使用游戏金币等虚拟货币兑换虚拟道具或其他商品与/或服务时，我们会收集您的</span>-->
<!--          <span class="boldT">兑换的内容、兑换时间等兑换记录信息。</span>-->
<!--        </div>-->
<!--        <div class="boldT line">(四)玩家交流互动</div>-->
<!--        <div class="line">-->
<!--          <span>当您在游戏中与其他玩家进行语音、文字交流时，我们需要收集您</span>-->
<!--          <span class="boldT">发布的上述信息，</span>-->
<!--          <span>以实现玩家间的交流互动。当您使用剪贴板功能在游戏内交流互动时，我们会申请您的</span>-->
<!--          <span class="boldT">剪贴板权限;</span>-->
<!--          <span>当您使用当您以语音的形式与其他玩家交流互动时，我们会申请您的</span>-->
<!--          <span class="boldT">麦克风权限，</span>-->
<!--          <span>如您拒绝，仅使您无法使用该功能，但不影响您使用我们的其他服务。</span>-->
<!--        </div>-->
<!--        <div class="line">为了符合相关法律法规要求，履行网络信息内容生态治理义务，为用户提供文明健康的游戏环境，禁止违法和不良信息的发布和传播，就您发布的内容，我们会通过机器及人工等方式进行审核。请您放心，我们仅会为实现上述目的对您发布的内容进行审核，不会进行其他处理。</div>-->
<!--        <div class="boldT line">(五)市场推广与消息通知</div>-->
<!--        <div class="line">1.游戏预约</div>-->
<!--        <div class="line">-->
<!--          <span>在我们的新游戏开展测试、正式上线前，我们可能会收集您的在预约页面主动填写的</span>-->
<!--          <span class="boldT">手机号码</span>-->
<!--          <span>，以便在新游戏开始线上测试或正式运营前，向您进行通知，方便您下载游戏。</span>-->
<!--        </div>-->
<!--        <div class="line">2.活动参与</div>-->
<!--        <div class="line">-->
<!--          <span>当您参与我们的活动，如抽奖、竞猜、答题、问卷调查时，我们可能会收集您的相关信息。例如:在您参与我们的游戏运营活动时，我们可能会收集您的</span>-->
<!--          <span class="boldT">账号信息、领取的福利信息、参与活动的记录。</span>-->
<!--        </div>-->
<!--        <div class="line">3.营销及消息通知</div>-->
<!--        <div class="line">-->
<!--          <span>对于您在使用过程中提供的您的</span>-->
<!--          <span class="boldT">联系方式(包括联系电话、联系邮箱、QQ号)</span>-->
<!--          <span>，我们在运营中可能会向其中的一种或多种发送多类通知，用于用户消息告知、身份验证、安全验证、用户使用体验调研等用途。在经过您的授权同意后，我们可能会通过短信、电话及/或邮件的方式向您提供市场营销、商业活动等商业性信息。如您不愿接收我们的商业性信息，您可根据我们在本政策第四章节“撤回同意“指引的路径选择拒绝接收，您亦可以通过短信、电子邮件中提供的退订方式进行退订(例如:您可以通过回复“TD“退订我们发送给您的营销短信)。</span>-->
<!--        </div>-->
<!--        <div class="boldT line">(六)稳定运行、一致性体验和产品安全需要</div>-->
<!--        <div class="line">1.稳定运行及一致性体验</div>-->
<!--        <div class="line">-->
<!--          <span>为了保障您正常使用我们的产品与/或服务，维护游戏基础功能的正常和稳定运行，识别并解决您游戏中的进程错误、崩溃问题以优化游戏性能，提升您的用户体验等，我们需要收集您的</span>-->
<!--          <span class="boldT">设备信息</span>-->
<!--          <span>。前述设备信息包括:</span>-->
<!--          <span class="boldT">设备标识信息(Mac地址、IMEI、Android ID、Open UDID、IDFA、IDFV、OAID、ICCID及其他综合设备参数和系统信息形成的设备标识符)、移动应用列表、SIM卡信息、网络相关信息(IP地址、网络运营商、网络信息、网络状态、类型)、设备参数及系统信息(设备名称、设备型号、硬件序列号、操作系统、操作系统版本、系统语言手机制造商、分辨率、屏幕高宽、方向、CPU序列号、磁盘总空间、系统总内存空间)等全部或部分信息。</span>-->
<!--        </div>-->
<!--        <div class="line">-->
<!--          <span>为确保向您提供一致的游戏体验，我们需要收集您的</span>-->
<!--          <span class="boldT">登录日志、操作日志、游戏内权益及资产日志、游戏内道具日志、升级日志、活动日志、工会日志、游戏对局信息、游戏内交友记录等您在使用我们的产品与/或服务中产生的游戏日志信息</span>-->
<!--          <span>，便于对您的游戏进程存档，以实现您在客户端随时查询您的游戏历史记录;同时，为保证您在后续版本中一致性的游戏体验，我们可能会将前述信息同步至该游戏的后续版本。</span>-->
<!--        </div>-->
<!--        <div class="line">-->
<!--          <span>为实现横竖屏切换，我们会可能会调用您的</span>-->
<!--          <span class="boldT">加速度传感器、方向传感器、重力传感器、陀螺仪传感器</span>-->
<!--          <span>(具体以各游戏的实际使用为准)，以确认您的屏幕朝向。部分游戏中，为实现剧情展现和进行提示消息，我们会调用您的</span>-->
<!--          <span class="boldT">震动陀螺仪。</span>-->
<!--        </div>-->
<!--        <div class="line">2.产品安全需要</div>-->
<!--        <div class="line">-->
<!--          <span>为保障您使用我们的产品与/或服务时的账号与系统及交易安全，营造公平、健康及安全的游戏环境，打击干扰破坏游戏服务正常进行或破坏游戏公平环境的行为(如检测盗版、扫描外挂、防止作弊等)，提升我们的产品与/服务的安全性和可靠性，以防产生任何危害用户、四川繁羽开天科技有限公司集团、社会的行为，我们需要收集您的以下全部或部分信息，包括</span>-->
<!--          <span class="boldT">:设备信息、游戏进程及崩溃记录、游戏总体使用情况、游戏渠道来源、交易信息、账号及实名认证相关信息等。</span>-->
<!--          <span>同时，我们会使用您设备的</span>-->
<!--          <span class="boldT">相关传感器信息(如加速度传感器)，</span>-->
<!--          <span>以判断是否是真机，防止作弊行为。</span>-->
<!--        </div>-->
<!--        <div class="line">-->
<!--          <span>前述设备信息包括</span>-->
<!--          <span class="boldT">:设备标识信息(IMEI、Android ID、Open UDID、IDFA、IDFV、OAID、MAC地址及其他综合设备参数和系统信息形成的设备标识符)、移动应用列表、网络相关信息(IP地址、网络运营商、网络信息、网络状态、类型)、设备参数信息及系统信息(设备名称、硬件型号、硬件序列号、操作系统、操作系统版本、系统语言、手机制造商、分辨率、屏幕高宽、方向、CPU序列号、磁盘总空间、系统总内存空间)等。</span>-->
<!--        </div>-->
<!--        <div class="line">前述维护稳定运行、一致性体验和安全需要的相关信息在去标识化或匿名化处理后，可能用于内部研究、统计分析和预测，改善我们平台及服务的内容和布局，为商业决策提供产品或服务支撑，以及改进我们的产品和服务(包括使用匿名数据进行机器学习或模型算法训练)</div>-->
<!--        <div class="boldT line">(七)客户服务或其他用户响应功能</div>-->
<!--        <div class="line">-->
<!--          <span>当您使用我们的客户服务或其他用户响应功能时，为了您的账号与系统安全，我们可能需要您先行提供</span>-->
<!--          <span class="boldT">账号信息</span>-->
<!--          <span>并与您之前的个人信息相匹配以验证您的用户身份。同时，我们可能还会需要收集</span>-->
<!--          <span class="boldT">您的如下个人信息:联系方式(您与我们联系时使用的电话号码/电子邮箱或您向我们主动提供的其他联系方式)、您与我们的沟通信息(包括文字/图片/音视频/通话记录形式)、与您需求相关联的其他必要信息。</span>-->
<!--          <span>我们收集这些信息是为了调查事实与帮助您解决问题，如您拒绝提供可能导致您无法使用我们的客服等用户响应功能。</span>-->
<!--        </div>-->
<!--        <div class="line">-->
<!--          <span>当您使用在线客服沟通、意见反馈等的部分功能时，我们会请求您的</span>-->
<!--          <span class="boldT">相机、相册/存储权限，</span>-->
<!--          <span>并收集您的</span>-->
<!--          <span class="boldT">图片信息</span>-->
<!--          <span>。若您拒绝提供的，仅会使您无法使用该功能，但并不影响您正常使用产品与/或服务的其他功能。</span>-->
<!--        </div>-->
<!--        <div class="boldT line">(八)我们作为渠道方收集的场景</div>-->
<!--        <div class="line">我们可能作为渠道方提供四川繁羽开天科技有限公司游戏渠道服务，具体的信息收集等处理规则请见-->
<!--          <a href="https://kl3g96a53c.feishu.cn/docx/RRUcdTFqooWCoaxTFLFcvxL1ngy">四川繁羽开天科技有限公司游戏渠道SDK隐私规则</a>-->
<!--          。</div>-->
<!--        <div class="boldT line">(九)其他功能</div>-->
<!--        <div class="line">如果某一需要收集您的个人信息的功能或产品/服务未能在本政策中予以说明的，或者我们超出了与收集您的个人信息时所声称的目的及具有直接或合理关联范围的，我们会再次向您告知，并根据法律法规的相关要求征得您的同意。</div>-->
<!--      </div>-->
<!--      <div class="section">-->
<!--        <div class="boldT line">例外情形</div>-->
<!--        <div class="line">我们在以下情况下处理您的个人信息无需您的授权同意:</div>-->
<!--        <div class="line">1.为订立、履行个人作为一方当事人的合同所必需,</div>-->
<!--        <div class="line">2.为履行法定职责或者法定义务所必需;</div>-->
<!--        <div class="line">3.为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需;</div>-->
<!--        <div class="line">4.为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息;</div>-->
<!--        <div class="line">5.依照本法规定在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息</div>-->
<!--        <div class="line">6.法律、行政法规规定的其他情形。</div>-->
<!--  </div>-->
<!--      <div class="section">-->
<!--        <div class="boldT line">二、我们如何使用Cookie和同类技术</div>-->
<!--        <div class="line">Cookie是包含字符串的小文件，在您登入和使用网站或其他网络内容时发送、存放在您的计算机、移动设备或其他装置内(通常经过加密)。Cookie同类技术是可用于与Cookie类似用途的其他技术，例如:Web Beacon、Proxy、嵌入式脚本等。</div>-->
<!--        <div class="line">目前，我们主要使用Cookie收集您的个人信息。您知悉并同意，随着技术的发展和我们产品和服务的进一步完善我们也可能会使用Cookie同类技术。</div>-->
<!--        <div class="line">在您使用我们的产品与/或服务时，我们或我们合作伙伴等第三方可能会使用Cookie和同类技术收集您的一些个人信息，包括:您访问网站的习惯、您的浏览信息、您的登录信息，以便为您提供更优质的服务体验、保障服务安全。我们会严格要求第三方在本政策所述目的范围内使用Cookie和同类技术，明确约定合作伙伴无权将共享的个人信息用于任何其他用途，并告知合作伙伴需要履行对于个人信息的保密义务。</div>-->
<!--        <div class="line">-->
<!--          <span>如果您的浏览器允许，您可以通过您的浏览器的设置以管理Cookie和同类技术。</span>-->
<!--          <span class="boldT">您理解并知悉:我们的某些产品与/或服务只能通过使用Cookie或同类技术才可得到实现，如您拒绝使用或删除的，您将可能无法获得我们的产品与/或服务的最佳的服务体验，同时也可能会对您的信息保护和账号安全性造成一定的影响。</span>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="section">-->
<!--        <div class="boldT line">三、我们如何共享、转让、公开披露您的个人信息</div>-->
<!--        <div class="boldT line">(一) 共享</div>-->
<!--        <div class="line">我们在遵守“合法正当、最小必要、目的明确原则”及取得您的单独同意的前提下共享您的个人信息。</div>-->
<!--        <div class="line">如我们委托第三方处理您的个人信息的，我们将会与受托人约定委托范围、委托处理的目的、期限、处理方式、个人信息的种类、保护措施以及双方的权利和义务等，并对受托人的个人信息处理活动进行监督。在委托合同不生效、无效、被撤销或者终止时，我们会要求受托方返还个人信息或者将个人信息予以删除，不得保留。</div>-->
<!--        <div class="line">如果我们与第三方个人信息处理者共同决定您个人信息的处理目的和处理方式的，将与合作商约定各自的权利和义务，且该约定不影响您向其中任何一个个人信息处理者要求行使您的权利，且发生若侵害您的个人信息权益造成损害的，我们将依法承担连带责任。</div>-->
<!--        <div class="line">我们将对个人信息的共享活动事先进行个人信息保护影响评估，对输出形式、流转、使用等采取有效的技术保护措施。在合作协议层面，严格要求合作商的信息保护义务与责任，与业务合作商在合作前签署关于数据安全的保护协议。</div>-->
<!--        <div class="boldT line">1. 我们的合作商</div>-->
<!--        <div class="line">-->
<!--          <span>1)实名认证服务:为遵守法律法规关于网络游戏实名认证的要求，使您顺利使用我们相关产品与/或服务，我们会将您的</span>-->
<!--          <span class="boldT">姓名、身份证号实名信息</span>-->
<!--          <span>提交至国家新闻出版署网络游戏防沉迷实名验证系统进行真实身份验证</span>-->
<!--        </div>-->
<!--        <div class="line">-->
<!--          <span>2)支付服务:为保障交易安全、完成商品/服务的支付，我们会将您的</span>-->
<!--          <span class="boldT">订单支付相关信息</span>-->
<!--          <span>提供给提供支付服务的合作商。</span>-->
<!--        </div>-->
<!--        <div class="line">-->
<!--          <span>3)市场营销:我们会在第三方平台向您展示我们的部分游戏产品与/或服务。为了更好的向您展示我们的内容、评估市场营销效果等目的，我们需要向第三方服务平台共享您的部分数据，包括</span>-->
<!--          <span class="boldT">设备标识信息、QQ号。</span>-->
<!--        </div>-->
<!--        <div class="line">-->
<!--          <span>4)问题解决、纠纷处理:我们平台的部分活动/产品服务等由我们与合作商共同提供或主要由合作商提供，为解决您与我们及/或我们的合作商之间的投诉、纠纷等，我们可能在</span>-->
<!--          <span class="boldT">“最小必要“范围内向合作商提供解决问题、处理纠纷所需要的您的个人信息。</span>-->
<!--        </div>-->
<!--        <div class="line">5）代理发行:如果您使用我们代理发行的游戏产品，我们可能与开发主体或相关第三方共享您在游戏中产生的游戏日志及相关信息(如崩溃日志等)，用于游戏安全分析，完善游戏服务，进一步优化您的游戏体验。</div>-->
<!--        <div class="line">6）.在确保您的个人信息安全与目的正当的前提下，我们可能会向与我们合作的科研院所、高校等机构提供去标识化或匿名化的数据，用于相关领域的科研，促进科技发展。</div>-->
<!--        <div class="line">7）我们接受尽职调查或审计时，与外部监管、专业咨询机构(如审计机构)等共享您的相关信息。</div>-->
<!--        <div class="line">8）其他为实现我们的服务/功能所必需进行的共享。</div>-->
<!--      </div>-->
<!--      <div class="section">-->
<!--        <div class="boldT line">2.关联APP</div>-->
<!--        <div class="line">-->
<!--          <span>为便于我们向您提供一致化服务、完善用户体验、实现安全风控、提供客户服务之需要，功能有相应联系的关联App将适用统一账号体系。适用统一账号体系的关联公司App将同步您注册、登录、使用我们的产品与/或服务的些个人信息，主要包括</span>-->
<!--          <span class="boldT">:(1)您的设备信息;(2)您的基本资料信息，如头像等。</span>-->
<!--        </div>-->
<!--        <div class="line">注:</div>-->
<!--        <div class="line">“统一账号体系“指,对您在关联App中绑定的手机号码，创建统一的字符串，实现账号统一登录，并获得相关功能</div>-->
<!--        <div class="boldT line">3.第三方SDK类服务商</div>-->
<!--        <div class="line">为保障我们的客户端的稳定运行、功能实现，使您能够使用和享受更多的服务及功能，我们的应用中会嵌入业务合作商的软件工具开发包(SDK)或其他类似的应用程序。我们会对业务合作商获取信息的SDK、应用程序接口(API)进行严格的安全监测，令其按照本政策以及其他任何相关的保密和安全措施来处理个人信息，以保障数据安全。</div>-->
<!--        <div class="line">TapADN广告组件、ThinkingAnalyticsSDK、Unity3D 游戏引擎库获取了Android ID。查看-->
<!--          <a href="https://kl3g96a53c.feishu.cn/docx/UHjqdy6EboyP69x7IeBc9zwOnyp">四川繁羽开天科技有限公司游戏第三方SDK类服务商</a>-->
<!--          进一步了解。</div>-->
<!--        <div class="boldT line">4.游戏联运渠道SDK</div>-->
<!--        <div class="line">如果您是通过游戏联运渠道(如第三方平台、第三方应用商店等)获取、接入我们的产品与/或服务的，通常情况下，我们的产品与/或服务中的部分功能将通过联运渠道接入的渠道SDK实现，包括登录、实名认证、支付、客服等。在上述特定场景下，您需要授权渠道SDK收集、存储、使用或以其他方式处理您的个人信息，关于渠道SDK处理您的个人信息种类、目的、方式和您享有的权利等事宜，请见渠道SDK隐私政策或相关规则说明。如:您获取软件的渠道为小米应用商店，则(通常)我们的产品与/或服务会接入小米渠道SDK。查看-->
<!--          <a href="https://kl3g96a53c.feishu.cn/docx/NZkFdAN8OoWSbnxciEXc2fennZf">四川繁羽开天科技有限公司游戏渠道SDK清单</a>-->
<!--          进一步了解。</div>-->
<!--        <div class="boldT line">(二)转让</div>-->
<!--        <div class="line">转让是指将个人信息控制权向其他公司、组织或个人转移的过程。原则上我们不会将您的个人信息转让，但以下情况除外:</div>-->
<!--        <div class="line">1.您自行提出要求，且符合法律法规及监管的相关规定条件的。</div>-->
<!--        <div class="line">2.根据法律法规或强制性的行政或司法要求；</div>-->
<!--        <div class="line">3.如果我们因合并、分立、解散、被宣告破产的原因需要转移个人信息的，我们会向您告知接收方的名称或者姓名和联系方式，并要求接收方继续受本政策的约束。接收方变更原先的处理目的、处理方式的，我们将要求接收方重新取得您的同意。</div>-->
<!--        <div class="line">（三）公开披露</div>-->
<!--        <div class="line">-->
<!--          <span>原则上我们不会将用户的信息进行公开披露。确需展示时，我们会予以</span>-->
<!--          <span class="boldT">脱敏</span>-->
<!--          <span>。如确需要完全公开披露，我们将会向用户告知公开披露的目的、披露信息的类型及可能涉及的相关信息，并征得用户的</span>-->
<!--          <span class="boldT">单独同意。</span>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="section">-->
<!--        <div class="boldT line">四、您对个人信息享有的控制权</div>-->
<!--        <div class="line">-->
<!--          <span>我们非常重视您作为个人信息主体所享有的权利，并尽全力保护您对您的个人信息的控制权，为您提供多种方式方便您更安心、更便捷地进行隐私设置及个人信息管理，保障您的个人信息安全。请您理解，部分服务/功能需要处理您的个人信息方可实现，因此，如果您撤回我们对您信息处理的同意/授权，则可能会影响您使用相应服务/功能，但不影响您其他服务/功能的使用。同时，</span>-->
<!--          <span class="boldT">您撤回同意/授权的，不影响撤回前基于您的同意/授权已进行的个人信息处理的活动。</span>-->
<!--        </div>-->
<!--        <div class="boldT line">(一)查询、更正/修改、删除您的个人信息</div>-->
<!--        <div class="line">您可以在您使用的我们的游戏产品中查询与访问您的账号基础信息(如头像、昵称，以及其他您选择填写的个人信息)、游戏历史信息(如等级、战力、背包物品、对局记录，以及各产品特定的游戏信息)，并可对上述部分信息进行更正/修改、删除。</div>-->
<!--        <div class="line">对于您在行使上述权利过程中遇到的困难，如无法在线上自行更正/修改部分信息或当您发现我们处理的您的个人信息有错误时，您有权通过我们公布的反馈、报错等途径将您的更正/修改申请提交给我们，要求我们做出更正/修改。但出于安全性和身份识别的考虑，您可能无法修改注册时提交的某些初始注册信息。在以下情形中，您可以直接向我们提出删除您的个人信息的请求，但已做数据匿名化处理或法律法规另有规定的除外:</div>-->
<!--        <div class="line">1.处理目的已实现、无法实现或者为实现处理目的不再必要</div>-->
<!--        <div class="line">2.我们停止提供产品与/或服务，或者保存期限已届满;</div>-->
<!--        <div class="line">3.您撤回同意;</div>-->
<!--        <div class="line">4.我们违反法律、行政法规或者违反约定处理您的个人信息。您理解并同意:当您从我们的产品与/或服务中删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息或者将安全地存储用户的个人信息并将其与其他信息进一步处理隔离，直到备份可以清除或实现匿名。</div>-->
<!--        <div class="line">若我们决定响应用户的删除请求，我们还将同时通知从我们获得用户的个人信息的合作方，要求其及时删除，除非法律法规另有规定，或这些合作方获得用户的独立授权。</div>-->
<!--        <div class="boldT line">(二)撤回同意</div>-->
<!--        <div class="line">您可以通过以下方式改变或者撤回您授权我们处理您的个人信息的范围:</div>-->
<!--        <div class="line">1.系统权限设置:您可以通过设备系统设置管理我们产品使用的系统权限授权，例如:i0S设备中的“设置-隐私-照片“来撤回您对照片权限的授权。</div>-->
<!--        <div class="line">2.商业信息接收设置:您有权拒绝我们的商业性营销信息。例如:在疯狂原始人App"我的一账户安全一商业信息接收”中选择拒绝接收。</div>-->
<!--        <div class="line">3.除本政策中已有说明外，其他设置具体以产品实际提供为准，</div>-->
<!--        <div class="boldT line">（三)注销账号</div>-->
<!--        <div class="line">您可以通过以下方式注销您的账号</div>-->
<!--        <div class="line">1.线上注销。例如:在疯狂原始人App中通过路径:"游戏个人中心-账户安全-账户注销”申请注销账号。</div>-->
<!--        <div class="line">2.联系我们的客服进行账号注销。</div>-->
<!--        <div class="line">3.其他我们公示的途径。</div>-->
<!--        <div class="boldT line">在您注销账号后，该账号下的内容、信息、数据、记录等将会被删除或匿名化处理(但法律法规另有规定或监管部门另有要求的除外);同时，账号一旦注销完成，将无法恢复。</div>-->
<!--        <div class="line">更多关于四川繁羽开天科技有限公司账号注销的流程、注意事项等详见-->
<!--          <a href="https://kl3g96a53c.feishu.cn/docx/HCpVd2BJIo7p2SxdyAScOYWTnfg">《四川繁羽开天科技有限公司账号注销协议》</a>-->
<!--        </div>-->
<!--        <div class="boldT line">(四)提前获知产品与/或服务停止运营</div>-->
<!--        <div class="line">我们将持续为您提供优质服务，若因特殊原因导致我们的部分或全部产品与/或服务被迫停止运营，我们将提前在显著位置或向您发送推送消息或以其他方式通知您，并将停止对您的个人信息的收集，同时在超出法律法规规定的必需且最短期限后，我们将会对所持有的您的个人信息进行删除或匿名化处理，</div>-->
<!--        <div class="boldT line">(五)帮助与反馈</div>-->
<!--        <div class="line">我们为您提供了多种反馈渠道，具体请见本政策第八章节“如何联系我们"</div>-->
<!--      </div>-->
<!--      <div class="section">-->
<!--        <div class="boldT line">五、我们如何存储和保护您的个人信息</div>-->
<!--        <div class="boldT line">(一)个人信息的存储</div>-->
<!--        <div class="boldT line">1.存储地点</div>-->
<!--        <div class="line">-->
<!--          <span class="boldT">我们在中华人民共和国境内运营中收集和产生的个人信息存储于中华人民共和国境内。</span>-->
<!--          <span>仅在以下情形，目在满足法律法规及监管部门的相关规定后，我们可能会向境外主体提供您的个人信息，并将严格要求接收方按照相关法律法规要求及本政策来处理您的个人信息:</span>-->
<!--        </div>-->
<!--        <div class="line">(1)法律法规有明确规定;</div>-->
<!--        <div class="line">(2)另行获得您单独同意;</div>-->
<!--        <div class="line">(3)您使用的产品与/或服务涉及跨境，您主动向境外提供个人信息。但会向您告知境外接收方的名称或者姓名、联系方式、处理目的、处理方式、个人信息的种类以及用户向境外接收方行使法律规定权利的方式和程序等事项，当相关个人信息达到法定限额，我们会向主管机关申请个人信息出境安全评估。</div>-->
<!--        <div class="boldT line">2.存储期限:</div>-->
<!--        <div class="line">我们在为提供我们的产品与/或服务之目的所必需且最短的期间内保留您的个人信息，例如:当您使用我们的注册登录功能时，我们需要收集您的手机号码，且在您提供后并在您使用该功能期间，我们需要持续为您保留您的手机号码，以向您正常提供该功能、保障您的账号和系统安全在您主动删除个人信息、注销账号或超出必要的存储期限后，我们会对您的个人信息进行删除或匿名化处理，但法律法规另有规定的除外(例如:《电子商务法》规定:商品和服务信息、交易信息保存时间自交易完成之日起不少于三年)。</div>-->
<!--        <div class="line">我们判断个人信息的必要存储期限主要依据以下标准:</div>-->
<!--        <div class="line">(1)维护相应交易及业务记录，以应对您可能的查询或投诉;</div>-->
<!--        <div class="line">(2)保证我们为您提供服务的安全和质量;</div>-->
<!--        <div class="line">(3)您是否同意更长的留存期间；</div>-->
<!--        <div class="line">(4)是否存在保留期限内的其他特别约定。</div>-->
<!--        <div class="line">在您的个人信息超出存储期间后，我们会根据适用法律的要求删除您的个人信息，或对其进行匿名化处理。如我们停止运营，我们将及时停止继续收集个人信息的活动，对所持有的个人信息进行删除或匿名化处理。</div>-->
<!--        <div class="boldT line">(二)个人信息的保护措施</div>-->
<!--        <div class="line">我们一直都极为重视保护用户的个人信息安全，为此我们采用了符合行业标准的安全技术及组织和管理等保护措施以最大程度降低您的信息被泄露、毁损、误用、非授权访问、非授权披露和更改的风险。包括:</div>-->
<!--        <div class="line">1.采用多种安全技术措施对数据的收集、传输、存储、处理、销毁、审计等环节进行管控。</div>-->
<!--        <div class="line">2.建立个人信息安全保护组织，落实个人信息安全规范处理、信息安全宣贯与培训等措施。</div>-->
<!--        <div class="line">3.构建并完善包括安全体系认证、业务安全能力认证及网络安全等级保护认证的个人信息安全管理体系</div>-->
<!--        <div class="line">4.建立安全应急响应体系、安全事件应急处理机制，及时、高效完成安全事件处理</div>-->
<!--        <div class="line">请您知悉并理解，互联网并非绝对安全的环境，我们强烈建议您通过安全方式、使用复杂密码、定期修改密码、不将自己的账号密码及相关个人信息披露给他人等方式，协助我们保证您的账号安全。如您发现自己的个人信息泄密，尤其是您的账户或密码发生泄露，请您立即根据本隐私政策文未中提供的联系方式联络我们，以便我们采取相应措施来保护您的信息安全。</div>-->
<!--      </div>-->
<!--      <div class="section">-->
<!--        <div class="boldT line">六、未成年人保护</div>-->
<!--        <div class="line">-->
<!--          <span>我们一直非常注重对未成年人的保护，致力于践行我们的企业社会责任。</span>-->
<!--          <span class="boldT">我们按照国家防沉迷政策要求接入国家防沉迷系统，通过实名认证校验程序确保将未成年人账号纳入防沉迷管理，积极引导未成年人合理游戏，保护未成年人的合法权益。</span>-->
<!--        </div>-->
<!--        <div class="line">如您为未成年人，应首先取得其监护人的同意(包括本政策)，在监护人同意后和指导下进行使用、提交个人信息。</div>-->
<!--        <div class="line">如果您是14周岁以下儿童的，在您使用我们的服务前，请您通知您的监护人阅读我们的-->
<!--          <a href="https://kl3g96a53c.feishu.cn/docx/AHJ4dCNFyouETvxl5sDc1mBGnTc">四川繁羽开天科技有限公司儿童信息保护规则</a>-->
<!--          ，并请您在监护人的授权同意后，在监护人的指导下使用我们的产品与/或服务。对于经监护人同意使用我们的产品与/或服务的情况，我们只会在法律法规允许、监护人明确同意或者保护未成年人所必要的情况下收集、使用、共享、转让或公开披露。更多有关我们对儿童个人信息的处理和保护规则等，请查阅《四川繁羽开天科技有限公司儿童个人信息保护规则》</div>-->
<!--      </div>-->
<!--      <div class="section">-->
<!--        <div class="boldT line">七、本政策的更新</div>-->
<!--        <div class="line">-->
<!--          <span class="boldT">我们鼓励您在使用我们的产品或服务前仔细查阅我们的《四川繁羽开天科技有限公司游戏隐私政策》</span>-->
<!--          <span>。为了给您提供更好的服务，我们会根据产品的更新情况及法律法规的相关要求更新本政策的条款，该更新构成本政策的一部分。我们会通过站内信或其他适当的方式提醒您更新的内容，以便您及时了解本政策的最新版本。如该更新涉及重大变更，我们将在本政策生效前通过显著方式向您进行通知(如网站公示、弹窗方式)。但未经您明确同意，我们不会减损或侵害您依据本政策享有的个人权益。</span>-->
<!--        </div>-->
<!--      </div>-->
<!--      <div class="section">-->
<!--        <div class="boldT line">八、如何联系我们</div>-->
<!--        <div class="line">(一)关于我们</div>-->
<!--        <div class="line">我们的运营主体是四川繁羽开天科技有限公司传媒有限公司，基本情况如下</div>-->
<!--        <div class="line">成立时间:2024年06月04日</div>-->
<!--        <div class="line">注册地址/常用办公地址:中国(四川)自由贸易试验区成都高新区交子大道233号4-8楼</div>-->
<!--        <div class="line">联系电话:19150010379</div>-->
<!--        <div class="line">关联公司是指控制四川繁羽开天科技有限公司传媒有限公司、受四川繁羽开天科技有限公司传媒有限公司控制或与四川繁羽开天科技有限公司传媒有限公司处于共同控制下的公司、机构。控制指通过所有权、有投票权的股份、合同、实际运营关联或其他被依法认定的方式直接或间接地拥有影响被控制对象管理/经营的能力。</div>-->
<!--        <div class="line">(二)联系我们</div>-->
<!--        <div class="line">如您对本政策的执行或对我们的隐私保护相关事宜有任何投诉、建议、疑问，您可通过以下方式联系我们，我们会在验证您的用户身份后的15个工作日内向您回复:</div>-->
<!--        <div class="line">1.专设的邮件通道:为更好地保护您的权益，我们专门设立了kf@sinegames.com.cn邮箱,您可以通过该邮箱与我们联系;</div>-->
<!--        <div class="line">2.个人信息保护专员: 您可发送邮件至kf@sinegames.com.cn或写信至以下地址来与其联系:中国(四川)自由贸易试验区成都高新区交子大道233号4-8楼 法律部 个人信息保护专员(收);邮编:610094;</div>-->
<!--        <div class="line">3.在线客服/其他在线意见反馈通道:您可与我们平台上产品功能页面的在线客服联系或者在线提交意见反馈;</div>-->
<!--        <div class="line">4.人工客服通道:您可以拨打我们的任何一部客服电话与我们联系。</div>-->
<!--        <div class="line">我们将在收到您的请求后并完成身份验证后15日内完成用户的处理响应，协助解决您的问题。为保障我们高效处理您的问题并及时向您反馈，我们可能会验证您的身份并要求您提供相关证据，我们会在验证用户的身份后处理您的请求。</div>-->
<!--      </div>-->
<!--      <div class="section">-->
<!--        <div class="boldT line">九、其他</div>-->
<!--        <div class="line">(一)本政策所称“四川繁羽开天科技有限公司游戏”，主要包括我们合法拥有、管理并运营的各类游戏客户端应用程序(包括但不限于PC端、移动端、小程序端等全部终端客户端)、官方网站及供第三方客户端应用程序及/或官方网站使用的网页、软件开发工具包(SDK)和应用程序编程接口(API)</div>-->
<!--        <div class="line">(二)本政策适用于四川繁羽开天科技有限公司游戏产品与/或服务，但如其中的部分产品与/或服务(包括但不限于某项产品与或服务、某类型终端客户端)单独设置了隐私条款/隐私协议的，单独的隐私条款/隐私协议优先适用，单独的隐私条款/隐私协议未提及的内容，适用本政策。</div>-->
<!--        <div class="line">请您注意，本政策不适用于以下情况:我们的产品与/或服务中包含的或链接至第三方提供的产品与/或服务(包括任何第三方客户端应用程序、网站及/或其他产品与/或服务)，这些产品与/或服务由第三方负责运营，您使用该产品与/或服务适用第三方另行向您说明的个人信息处理规则，除本政策外，在特定场景下，我们将以及时告知的方式(包括但不限于更新本政策、重新签署文件、页面提示、弹窗、站内信、邮件、网站公告或其他便于您获知的方式)另行向您详细说明对应信息的处理目的、方式、范围等规则，并在征得您的授权同意后处理(如适用)。</div>-->
<!--        <div class="boldT line">(三)本政策的解释及争议解决均应适用中华人民共和国大陆地区法律。如就本政策的签订、履行等发生任何争议的，双方应尽量友好协商解决:协商不成时，任何一方均可向成都市高新区人民法院提起诉讼。</div>-->
<!--        <div class="line">(四)本政策的标题仅为方便及阅读而设，不影响本协议任何条款的含义或解释。</div>-->
<!--      </div>-->
<!--      <div class="section">-->
<!--        <div class="line">四川繁羽开天科技有限公司</div>-->
<!--      </div>-->
<!--    </div>-->

    <div id="content" class="content-box">
      <div class="content">
        <div class="head">四川繁羽开天科技有限公司游戏隐私政策</div>
        <div class="section">
          <div class="line">导言</div>
          <div class="line">更新时间：2025年8月5日</div>
          <div class="line">生效时间：2025年8月5日</div>
          <div class="line">
            <span>“四川繁羽开天科技有限公司游戏”(以下亦称“我们的产品与/或服务”)指由四川繁羽开天科技有限公司传媒有限公司及/或其关联公司(以下亦称“四川繁羽开天科技有限公司”、“我们”)提供的网络游戏类产品与/或服务。我们深知个人信息对您的重要性，因此我们非常重视保护您的隐私和个人信息。我们希望通过本《四川繁羽开天科技有限公司游戏隐私政策》(以下亦称“本政策”)向您清晰地介绍您在使用我们的产品与/或服务时，我们如何处理您的个人信息，以及我们为您提供的管理、保护这些信息的方式。</span>
            <span class="boldT">涉及本政策中与您的权益(可能)存在重大关系的条款以及涉及敏感个人信息的处理，我们已经以字体加粗、下划线或其他合理方式提示您重点阅读。您可以拒绝向我们提供这些个人敏感信息，但是拒绝提供这些信息会影响用户使用本产品和/或服务项下的特定功能。</span>
          </div>
          <div class="boldT">
            您同意我们为遵守法律法规的要求及/或为实现产品功能和服务需要，将依据本隐私政策的约定对您的相关个人信息进行处理。但这并不代表只要您开始使用我们的产品与/或服务，我们将处理本政策中涉及的全部个人信息。仅当您使用特定功能及/或为遵守法律法规的要求时，我们会根据“最小必要"原则，为实现明确合理的目的，处理您的相关个人信息。
          </div>
        </div>
        <div class="section">
          <div class="boldT line">本《四川繁羽开天科技有限公司游戏隐私政策》将帮助您了解以下内容</div>
          <div class="line">一、我们如何收集和使用您的个人信息</div>
          <div class="line">二、我们如何使用Cookie和同类技术</div>
          <div class="line">三、我们如何共享、转让、公开披露您的个人信息</div>
          <div class="line">四、您对个人信息享有的控制权</div>
          <div class="line">五、我们如何存储和保护您的个人信息</div>
          <div class="line">六、未成年人保护</div>
          <div class="line">七、本政策的更新</div>
          <div class="line">八、如何联系我们</div>
          <div class="line">九、其他</div>
        </div>

        <div class="section">
          <div class="boldT line">一、我们如何收集和使用您的个人信息</div>
          <div class="line">
            <span>相机、相册/存储、麦克风等系统权限均不会默认开启，只有经过您单独同意后，才会在为实现特定功能/服务时访问</span>
            <span class="boldT">即使经过您的授权，可以访问您的相应权限，我们仅会在您的授权范围内进行访问,并获取相应信息(如涉及):且您可随时撤回授权，在您撤回授权后，我们将停止访问相应权限，也将无法再为您提供与之对应的某些服务，但不影响您享受我们提供的其他服务。查看</span>
            <a href="https://kl3g96a53c.feishu.cn/docx/WUDLdptKUofm0OxNaQccLZXvnoc">四川繁羽开天科技有限公司游戏应用权限使用情况说明</a>
            <span>。</span>
          </div>
        </div>

        <div class="section">
          <div class="boldT line">《四川繁羽开天科技有限公司游戏应用权限使用情况说明》</div>
          <div class="line">四川繁羽开天科技有限公司游戏产品与/或服务系统权限使用情况说明见下表：</div>
        </div>

        <div class="section">
          <div class="boldT line">Android端</div>
          <div class="boldT line">一、存储</div>
          <div class="line">
            <span>权限名称：</span><span class="boldT">READ_EXTERNAL_STORAGE读取外置存储器</span>
          </div>
          <div class="line">
            使用目的：读取您设备的外置存储器中的游戏资源信息，帮助您实现游戏进程加载；读取您选定的图片等文件，帮助您实现与客服的图文沟通等
          </div>
          <div class="line">涉及信息：存储的文件</div>
          <div class="line">权限名称：<span class="boldT">WRITE_EXTERNAL_STORAGE写入外置存储器</span></div>
          <div class="line">
            使用目的：部分渠道SDK将App内的游戏缓存、崩溃日志等信息存储至您设备的外置存储空间，帮助您实现游戏更新等
          </div>
          <div class="line">涉及信息：存储的文件</div>

          <div class="boldT line">二、相机</div>
          <div class="line">
            <span>权限名称：</span><span class="boldT">NSCameraUsageDescription使用摄像头</span>
          </div>
          <div class="line">使用目的：获取您拍摄的图片信息，帮助您实现与客服的图文沟通等</div>
          <div class="line">涉及信息：图片信息</div>

          <div class="boldT line">三、麦克风</div>
          <div class="line">
            <span>权限名称：</span>
            <span class="boldT">READ_AUDIO录音</span>
          </div>
          <div class="line">使用目的：获取您的音频信息，帮助您实现在游戏中进行语音交流等</div>
          <div class="line">涉及信息：语音信息</div>

          <div class="boldT line">四、电话</div>
          <div class="line">
            <span>权限名称：</span>
            <span class="boldT">READ_PHONE_STATE读取电话状态</span>
          </div>
          <div class="line">使用目的：读取设备标识等常用设备信息，根据您的设备信息，为您提供安全保障、风险控制等</div>
          <div class="line">涉及信息：用户常用设备标识信息</div>


          <div class="boldT line"> 五、IP</div>
          <div class="line">
            <span>权限名称： </span><span class="boldT">ACCESS_NETWORK_STATE 获取网络状态</span>
          </div>
          <div class="line">使用目的：获取设备网络连接状态及 IP
            地址信息，用于保障网络服务正常交互、实现精准的网络适配及安全验证等
          </div>
          <div class="line">涉及信息：用户设备的 IP 地址信息</div>

          <div class="boldT line"> 六、IMEI</div>
          <div class="line">
            <span>权限名称：</span> <span class="boldT">READ_PHONE_STATE 读取电话状态</span>
          </div>
          <div class="line">使用目的：获取设备唯一的 IMEI 标识，用于设备身份验证、防止恶意注册及保障服务安全等</div>
          <div class="line">涉及信息：用户设备的 IMEI 码信息</div>

          <div class="boldT line"> 七、短信</div>
          <div class="line">
            <span>权限名称：</span> <span class="boldT">READ_SMS 读取短信内容</span>
          </div>
          <div class="line">
            使用目的：读取短信中的验证码信息，以便为您提供快捷的登录、注册或身份验证服务，减少手动输入操作
          </div>
          <div class="line">涉及信息：用户短信中的验证码内容、发送号码及接收时间等信息</div>

          <div class="boldT line"> 八、应用软件列表</div>
          <div class="line">
            <span>权限名称：</span> <span class="boldT">GET_INSTALLED_PACKAGES 获取已安装应用列表</span>
          </div>
          <div class="line">使用目的：了解您设备上的应用软件情况</div>
          <div class="line">涉及信息：用户设备上已安装的应用软件名称、包名及版本信息等</div>

        </div>
        <div class="section">
          <div class="boldT line">iOS端</div>
          <div class="boldT line">一、相册</div>
          <div class="line">
            <span>权限名称：</span>
            <span class="boldT">NSPhotoLibraryUsageDescription读取相册中内容</span>
          </div>
          <div class="line">使用目的：读取您设备相册中您选定的图片内容等信息，帮助您实现与客服的图文沟通等</div>
          <div class="line">涉及信息：存储的文件</div>

          <div class="boldT line">二、相机</div>
          <div class="line">
            <span>权限名称：</span>
            <span class="boldT">NSCameraUsageDescription使用摄像头</span>
          </div>
          <div class="line">使用目的：获取您拍摄的图片信息，帮助您实现与客服的图文沟通等</div>
          <div class="line">涉及信息：图片信息</div>

          <div class="boldT line">三、麦克风</div>
          <div class="line">
            <span>权限名称：</span>
            <span class="boldT">NSMicrophoneUsageDescription使用麦克风</span>
          </div>
          <div class="line">使用目的：获取您的音频信息，帮助您实现在游戏中进行语音交流等</div>
          <div class="line">涉及信息：语音信息</div>

          <div class="boldT line">四、设备标识信息</div>
          <div class="line">
            <span>权限名称：</span>
            <span class="boldT">NSUserTrackingUsageDescription读取设备标识</span>
          </div>
          <div class="line">使用目的：读取设备标识信息，根据您的设备标识信息，为您提供安全保障、风险控制等</div>
          <div class="line">涉及信息：IDFA</div>


          <div class="boldT line"> 五、IP</div>
          <div class="line">
            <span>权限名称： </span><span class="boldT">ACCESS_NETWORK_STATE 获取网络状态</span>
          </div>
          <div class="line">使用目的：获取设备网络连接状态及 IP
            地址信息，用于保障网络服务正常交互、实现精准的网络适配及安全验证等
          </div>
          <div class="line">涉及信息：用户设备的 IP 地址信息</div>

          <div class="boldT line"> 六、IMEI</div>
          <div class="line">
            <span>权限名称：</span> <span class="boldT">READ_PHONE_STATE 读取电话状态</span>
          </div>
          <div class="line">使用目的：获取设备唯一的 IMEI 标识，用于设备身份验证、防止恶意注册及保障服务安全等</div>
          <div class="line">涉及信息：用户设备的 IMEI 码信息</div>

          <div class="boldT line"> 七、短信</div>
          <div class="line">
            <span>权限名称：</span> <span class="boldT">READ_SMS 读取短信内容</span>
          </div>
          <div class="line">
            使用目的：读取短信中的验证码信息，以便为您提供快捷的登录、注册或身份验证服务，减少手动输入操作
          </div>
          <div class="line">涉及信息：用户短信中的验证码内容、发送号码及接收时间等信息</div>

          <div class="boldT line"> 八、应用软件列表</div>
          <div class="line">
            <span>权限名称：</span> <span class="boldT">GET_INSTALLED_PACKAGES 获取已安装应用列表</span>
          </div>
          <div class="line">使用目的：了解您设备上的应用软件情况</div>
          <!-- ，以便为您提供更适配的功能服务、应用推荐及确保本应用与其他软件的兼容性-->
          <div class="line">涉及信息：用户设备上已安装的应用软件名称、包名及版本信息等</div>
        </div>

        <div class="section">
          <div class="boldT line">我们主要通过以下途径收集您在使用我们的产品与/或服务时涉及的个人信息:</div>
          <div class="line">1.根据业务需要您主动提供的信息，例如:注册账号时提供的手机号码。</div>
          <div class="line">2.我们收集、记录、汇总的信息，例如:您的设备信息、游戏日志信息。</div>
          <div class="line">3.我们从第三方间接获取的您的信息，例如:账号授权登录时，第三方平台提供的您的昵称和头像。</div>
          <div class="boldT"></div>
        </div>

        <div class="section">
          <div class="boldT line">通常情况下，我们会出于以下功能/场景的实现，收集和使用您的个人信息或申请相关权限:</div>
          <div class="boldT line">(一)账号注册与登录</div>
          <div class="line">
            <span>注册/登录:当您注册、登录我们的产品与/或服务时，为了帮助您顺利完成注册/登录流程,您需要向我们提供您的</span>
            <span class="boldT">手机号码、四川繁羽开天科技有限公司游戏账号登录密码信息。收集您的手机号码是为了满足相关法律法规的网络实名制要求如您拒绝提供手机号码进行核验，将导致注册/登录失败，您将无法使用我们的产品与/或服务。</span>
            <span>若您采用邮箱方式登录，则需要向我们提供您的</span>
            <span class="boldT">电子邮箱信息、四川繁羽开天科技有限公司游戏账号登录密码信息。</span>
          </div>
          <div class="line">
            <span>授权登录:您使用第三方平台(例如:QQ/微信等账号)的账号授权登录时，您授权我们获取</span>
            <span class="boldT">该第三方账号下的相关信息(包括昵称、头像，具体以您的授权范围为准)，</span>
            <span>用于与四川繁羽开天科技有限公司游戏账号绑定、网络资料信息的完孝</span>
          </div>
          <div class="line">
            手机号码绑定解除:信通院提供的“码号公共服务平台”对符合条件的手机号码提供一键解绑服务，我们在收到信通院的指令后，将直接解除该手机号码与对应四川繁羽开天科技有限公司游戏账号的绑定关系，并删除或匿名化处理该手机号码信息。
          </div>
          <div class="line">
            <span>资料维护:根据游戏的具体情况，您可自主选择填写您的</span>
            <span class="boldT">昵称、头像、性别、出生日期、地区、个性签名等部分或全部信息，</span>
            <span>以实现更好的社交体验。</span>
            <span class="boldT">如您未填写，不影响您使用我们产品与/或服务的其他功能。</span>
            <span>您在上传/更换头像时，我们可能会请求您的</span>
            <span class="boldT">相机、相册/存储权限，</span>
            <span>并收集您上传/更换的</span>
            <span class="boldT">图片信息。</span>
          </div>
          <div class="line">
            <span>账号信息公开:您的</span>
            <span class="boldT">个人资料、获赞、皮肤等部分或全部信息</span>
            <span>可能会在您的个人/角色空间页公开展示。</span>
          </div>
          <div class="boldT line">(二)实名认证</div>
          <div class="line">
            <span>为满足相关法律法规和主管部门关于游戏实名认证及防止未成年人沉迷网络游戏的要求，您需进行实名认证以继续使用我们的产品与/或服务。我们会在获得您同意或您主动提供的情况下收集您的</span>
            <span class="boldT">实名身份信息(包括姓名、身份证号)，并将其提交至国家新闻出版署网络游戏防沉迷实名验证系统进行真实身份验证，拒绝提供实名身份信息可能会导致您无法使用我们的产品与/或服务。如根据实名身份信息我们判断您为未成年人，依照相关法律法规及主管部门要求，您的游戏时间、游戏时长、付费服务等将会受到相关限制。</span>
          </div>
          <div class="boldT line">(三)游戏充值、兑换</div>
          <div class="line">1.充值</div>
          <div class="line">1)下单</div>
          <div class="line">
            <span>当您对游戏金币等虚拟货币或其他商品/服务进行下单时，我们需要收集如下部分或全部的个人信息，包括:您的</span>
            <span class="boldT">交易信息、订单编号、下单时间、订单金额等，</span>
            <span>我们收集这些信息是为了帮助您顺利完成前述购买、保障您的交易安全、查询订单信息、提供客户服务等。同时，为便于您了解、查询订单信息并对订单信息进行管理，我们会在我们的产品与/或服务中向您展示您支付成功的订单信息。</span>
          </div>
          <div class="line">2）支付</div>
          <div class="line">
            <span>为完成订单支付、保障交易安全，我们需要收集您的</span>
            <span class="boldT">交易金额、下单时间、订单商户、订单编号、支付方式、支付账号、支付状态信息，</span>
            <span>并通过安全方式与支付机构(如微信、支付宝)进行前述部分或全部信息的共享。</span>
          </div>
          <div class="line">
            <span>同时，若您使用我们产品与/或服务中的人脸/指纹支付功能的，您需要在您的本地设备端提前录入人脸或指纹信息，并在使用服务时在您的设备上完成信息验证。</span>
            <span class="boldT">我们需要使用您的面容ID/触控ID权限(生物识别身份验证权限)以便接收验证结果，但我们并不收集您的人脸或指纹信息。</span>
            <span>若您不开启此权限，您将无法使用前述服务，但不影响您选择其他支付方式。</span>
          </div>
          <div class="line">3）兑换</div>
          <div class="line">
            <span>当您使用游戏金币等虚拟货币兑换虚拟道具或其他商品与/或服务时，我们会收集您的</span>
            <span class="boldT">兑换的内容、兑换时间等兑换记录信息。</span>
          </div>
          <div class="boldT line">(四)玩家交流互动</div>
          <div class="line">
            <span>当您在游戏中与其他玩家进行语音、文字交流时，我们需要收集您</span>
            <span class="boldT">发布的上述信息，</span>
            <span>以实现玩家间的交流互动。当您使用剪贴板功能在游戏内交流互动时，我们会申请您的</span>
            <span class="boldT">剪贴板权限;</span>
            <span>当您使用当您以语音的形式与其他玩家交流互动时，我们会申请您的</span>
            <span class="boldT">麦克风权限，</span>
            <span>如您拒绝，仅使您无法使用该功能，但不影响您使用我们的其他服务。</span>
          </div>
          <div class="line">
            为了符合相关法律法规要求，履行网络信息内容生态治理义务，为用户提供文明健康的游戏环境，禁止违法和不良信息的发布和传播，就您发布的内容，我们会通过机器及人工等方式进行审核。请您放心，我们仅会为实现上述目的对您发布的内容进行审核，不会进行其他处理。
          </div>
          <div class="boldT line">(五)市场推广与消息通知</div>
          <div class="line">1.游戏预约</div>
          <div class="line">
            <span>在我们的新游戏开展测试、正式上线前，我们可能会收集您的在预约页面主动填写的</span>
            <span class="boldT">手机号码</span>
            <span>，以便在新游戏开始线上测试或正式运营前，向您进行通知，方便您下载游戏。</span>
          </div>
          <div class="line">2.活动参与</div>
          <div class="line">
            <span>当您参与我们的活动，如抽奖、竞猜、答题、问卷调查时，我们可能会收集您的相关信息。例如:在您参与我们的游戏运营活动时，我们可能会收集您的</span>
            <span class="boldT">账号信息、领取的福利信息、参与活动的记录。</span>
          </div>
          <div class="line">3.营销及消息通知</div>
          <div class="line">
            <span>对于您在使用过程中提供的您的</span>
            <span class="boldT">联系方式(包括联系电话、联系邮箱、QQ号)</span>
            <span>，我们在运营中可能会向其中的一种或多种发送多类通知，用于用户消息告知、身份验证、安全验证、用户使用体验调研等用途。在经过您的授权同意后，我们可能会通过短信、电话及/或邮件的方式向您提供市场营销、商业活动等商业性信息。如您不愿接收我们的商业性信息，您可根据我们在本政策第四章节“撤回同意“指引的路径选择拒绝接收，您亦可以通过短信、电子邮件中提供的退订方式进行退订(例如:您可以通过回复“TD“退订我们发送给您的营销短信)。</span>
          </div>
          <div class="boldT line">(六)稳定运行、一致性体验和产品安全需要</div>
          <div class="line">1.稳定运行及一致性体验</div>
          <div class="line">
            <span>为了保障您正常使用我们的产品与/或服务，维护游戏基础功能的正常和稳定运行，识别并解决您游戏中的进程错误、崩溃问题以优化游戏性能，提升您的用户体验等，我们需要收集您的</span>
            <span class="boldT">设备信息</span>
            <span>。前述设备信息包括:</span>
            <span class="boldT">设备标识信息(Mac地址、IMEI、Android ID、Open UDID、IDFA、IDFV、OAID、ICCID及其他综合设备参数和系统信息形成的设备标识符)、移动应用列表、SIM卡信息、网络相关信息(IP地址、网络运营商、网络信息、网络状态、类型)、设备参数及系统信息(设备名称、设备型号、硬件序列号、操作系统、操作系统版本、系统语言手机制造商、分辨率、屏幕高宽、方向、CPU序列号、磁盘总空间、系统总内存空间)等全部或部分信息。</span>
          </div>
          <div class="line">
            <span>为确保向您提供一致的游戏体验，我们需要收集您的</span>
            <span class="boldT">登录日志、操作日志、游戏内权益及资产日志、游戏内道具日志、升级日志、活动日志、工会日志、游戏对局信息、游戏内交友记录等您在使用我们的产品与/或服务中产生的游戏日志信息</span>
            <span>，便于对您的游戏进程存档，以实现您在客户端随时查询您的游戏历史记录;同时，为保证您在后续版本中一致性的游戏体验，我们可能会将前述信息同步至该游戏的后续版本。</span>
          </div>
          <div class="line">
            <span>为实现横竖屏切换，我们会可能会调用您的</span>
            <span class="boldT">加速度传感器、方向传感器、重力传感器、陀螺仪传感器</span>
            <span>(具体以各游戏的实际使用为准)，以确认您的屏幕朝向。部分游戏中，为实现剧情展现和进行提示消息，我们会调用您的</span>
            <span class="boldT">震动陀螺仪。</span>
          </div>
          <div class="line">2.产品安全需要</div>
          <div class="line">
            <span>为保障您使用我们的产品与/或服务时的账号与系统及交易安全，营造公平、健康及安全的游戏环境，打击干扰破坏游戏服务正常进行或破坏游戏公平环境的行为(如检测盗版、扫描外挂、防止作弊等)，提升我们的产品与/服务的安全性和可靠性，以防产生任何危害用户、四川繁羽开天科技有限公司集团、社会的行为，我们需要收集您的以下全部或部分信息，包括</span>
            <span class="boldT">:设备信息、游戏进程及崩溃记录、游戏总体使用情况、游戏渠道来源、交易信息、账号及实名认证相关信息等。</span>
            <span>同时，我们会使用您设备的</span>
            <span class="boldT">相关传感器信息(如加速度传感器)，</span>
            <span>以判断是否是真机，防止作弊行为。</span>
          </div>
          <div class="line">
            <span>前述设备信息包括</span>
            <span class="boldT">:设备标识信息(IMEI、Android ID、Open UDID、IDFA、IDFV、OAID、MAC地址及其他综合设备参数和系统信息形成的设备标识符)、移动应用列表、网络相关信息(IP地址、网络运营商、网络信息、网络状态、类型)、设备参数信息及系统信息(设备名称、硬件型号、硬件序列号、操作系统、操作系统版本、系统语言、手机制造商、分辨率、屏幕高宽、方向、CPU序列号、磁盘总空间、系统总内存空间)等。</span>
          </div>
          <div class="line">
            前述维护稳定运行、一致性体验和安全需要的相关信息在去标识化或匿名化处理后，可能用于内部研究、统计分析和预测，改善我们平台及服务的内容和布局，为商业决策提供产品或服务支撑，以及改进我们的产品和服务(包括使用匿名数据进行机器学习或模型算法训练)
          </div>
          <div class="boldT line">(七)客户服务或其他用户响应功能</div>
          <div class="line">
            <span>当您使用我们的客户服务或其他用户响应功能时，为了您的账号与系统安全，我们可能需要您先行提供</span>
            <span class="boldT">账号信息</span>
            <span>并与您之前的个人信息相匹配以验证您的用户身份。同时，我们可能还会需要收集</span>
            <span class="boldT">您的如下个人信息:联系方式(您与我们联系时使用的电话号码/电子邮箱或您向我们主动提供的其他联系方式)、您与我们的沟通信息(包括文字/图片/音视频/通话记录形式)、与您需求相关联的其他必要信息。</span>
            <span>我们收集这些信息是为了调查事实与帮助您解决问题，如您拒绝提供可能导致您无法使用我们的客服等用户响应功能。</span>
          </div>
          <div class="line">
            <span>当您使用在线客服沟通、意见反馈等的部分功能时，我们会请求您的</span>
            <span class="boldT">相机、相册/存储权限，</span>
            <span>并收集您的</span>
            <span class="boldT">图片信息</span>
            <span>。若您拒绝提供的，仅会使您无法使用该功能，但并不影响您正常使用产品与/或服务的其他功能。</span>
          </div>
          <div class="boldT line">(八)我们作为渠道方收集的场景</div>
          <div class="line">我们可能作为渠道方提供四川繁羽开天科技有限公司游戏渠道服务，具体的信息收集等处理规则请见
            <a href="https://kl3g96a53c.feishu.cn/docx/RRUcdTFqooWCoaxTFLFcvxL1ngy">四川繁羽开天科技有限公司游戏渠道SDK隐私规则</a>
            。
          </div>
        </div>

        <div class="section">
          <div class="boldT line">《四川繁羽开天科技有限公司游戏渠道SDK隐私规则》</div>
          <div class="line">
            本规则是针对四川繁羽开天科技有限公司游戏渠道服务作出的个人信息保护方面的陈述与承诺，属于《四川繁羽开天科技有限公司游戏隐私政策》的重要组成部分。涉及到四川繁羽开天科技有限公司游戏渠道服务特殊约定的，若与《四川繁羽开天科技有限公司游戏隐私政策》存在不一致的，以本规则为准；本规则未尽事宜，请您查阅参考
            <a href="https://kl3g96a53c.feishu.cn/docx/X7JZdH4hio3FC0xkdtXcC6OvnLd">四川繁羽开天科技有限公司游戏隐私政策</a>
            。
          </div>
          <div class="line">
            当四川繁羽开天科技有限公司做为渠道方接入第三方游戏软件时，为向您提供账号注册与登录、实名认证、订单支付、安全保障、客户服务、福利发放与活动参与等功能，我们将按照如下规则处理您的个人信息：
          </div>
          <div class="line"> 一、我们如何收集和使用您的个人信息</div>
          <div class="line"> 1、 账号注册与登录</div>
          <div class="line">
            注册/登录：当您注册、登录我们的产品与/或服务时，为了帮您顺利完成注册/登录流程，您需要向我们提供您的
            <span class="boldT">手机号码、账号登录密码信息。收集您的手机号码是为了满足相关法律法规的网络实名制要求，如您拒绝提供手机号码进行核验，将导致注册/登录失败，您将无法使用游戏产品与/或服务</span>
            。若您采用邮箱方式登录，则需要向我们提供您的
            <span class="boldT">电子邮箱信息、账号登录密码信息</span>
            。
          </div>
          <div class="line">
            授权登录：您使用第三方平台（例如：QQ/微信等账号）的账号授权登录时，您授权我们获取
            <span class="boldT">该第三方账号下的相关信息（包括昵称、头像，具体以您的授权范围为准）</span>
            ，用于与四川繁羽开天科技有限公司账号绑定、您网络资料信息的完善。
          </div>
          <div class="line">
            当您进行登录时，为了保障您使用我们的产品与/或服务时的账号与系统安全，营造公平、健康及安全的游戏环境，打击干扰、破坏游戏服务正常进行或破坏游戏公平环境的行为（如检测盗版、扫描外挂、防止作弊等），以防产生任何危害用户、四川繁羽开天科技有限公司集团、社会的行为等，我们需要收集您的
            <span class="boldT">设备信息（AndroidID、IMEI、IMSI、ICCID（SIM卡序列号））</span>
            。
          </div>
          <div class="line"> 2、 实名认证</div>
          <div class="line">
            为满足相关法律法规和主管部门关于游戏实名认证及防止未成年人沉迷网络游戏的要求，您需进行实名认证以继续使用游戏产品与/或服务。我们会在获得您同意或您主动提供的情况下收集您的
            <span class="boldT">实名身份信息（包括姓名、身份证号码），并将其提交至国家新闻出版署网络游戏防沉迷实名验证系统进行真实身份验证。特别说明，我们仅为实现上述目的使用您的身份证号码，不会存储您的身份证号码，如您拒绝提供实名身份信息可能会导致您无法使用游戏产品与/或服务。如根据实名身份信息我们判断您为未成年人，依照相关法律法规及主管部门要求，您的游戏时间、游戏时长、付费服务等将会受到相关限制</span>
            。
          </div>
          <div class="line"> 3、 游戏充值</div>
          <div class="line"> 1）下单</div>
          <div class="line">
            当您对游戏金币等虚拟货币或其他商品/服务进行下单时，我们需要收集如下部分或全部的个人信息，包括：您的
            <span class="boldT">交易信息、订单编号、下单时间、订单金额</span>
            等，我们收集这些信息是为了帮助您顺利完成前述购买、保障您的交易安全、查询订单信息、提供客户服务等。同时，为便于您了解、查询订单信息并对订单信息进行管理，我们会在我们的产品与/或服务中向您展示您支付成功的订单信息。
          </div>
          <div class="line"> 2）支付</div>
          <div class="line">
            为完成订单支付、保障交易安全，我们需要收集您的<span
              class="boldT">交易金额、下单时间、订单商户、订单编号、支付方式、支付账号、支付状态信息</span>
            ，并通过安全方式与支付机构（如微信、支付宝）进行前述部分或全部信息的共享。同时，为了完成您的虚拟道具或其他商品与/或服务兑换，我们会将您的支付结果共享至游戏产品提供方。
          </div>
          <div class="line">
            若您使用我们产品与/或服务中的人脸/指纹支付功能的，您需要在您的本地设备端提前录入人脸或指纹信息，并在使用服务时在您的设备上完成信息验证。
            <span class="boldT">我们需要使用您的面容ID/触控ID权限（生物识别身份验证权限）以便接收验证结果，但我们并不收集您的人脸或指纹信息</span>
            。若您不开启此权限，您将无法使用前述服务，但不影响您选择其他支付方式。
          </div>
          <div class="line"> 4、 稳定运行和安全风控</div>
          <div class="line">
            为了保障您正常使用我们的产品与/或服务，维护游戏基础功能的正常和稳定运行，识别并解决您游戏中的进程错误、崩溃问题以优化游戏性能，提升您的用户体验；同时，为了保障您使用我们的产品与/或服务时的账号与系统及交易安全，营造公平、健康及安全的游戏环境，打击干扰、破坏游戏服务正常进行或破坏游戏公平环境的行为（如检测盗版、扫描外挂、防止作弊等），以防产生任何危害用户、四川繁羽开天科技有限公司集团、社会的行为，我们需要收集您的设备信息，包括：设备标识信息（Android端：Android
            ID、IMEI、IMSI、ICCID（SIM卡序列号）、Mac地址、OAID、MEID；iOS端：Open
            UDID、IDFA、IDFV）、设备参数及系统信息（设备型号、操作系统、操作系统版本）。
          </div>
          <div class="line">
            上述信息在去标识化或匿名化处理后，可能用于内部研究、统计分析和预测，改善我们平台及服务的内容和布局，为商业决策提供产品或服务支撑，以及改进我们的产品和服务（包括使用匿名数据进行机器学习或模型算法训练）。
          </div>
          <div class="line"> 5、 客户服务</div>
          <div class="line">
            当您使用我们的客户服务或其他用户响应功能时，为了您的账号与系统安全，我们可能需要您先行提供
            <span class="boldT">账号信息</span>
            ，并与您之前的个人信息相匹配以验证您的用户身份。同时，我们可能还会需要收集您的如下个人信息：
            <span class="boldT">联系方式（您与我们联系时使用的电话号码/电子邮箱或您向我们主动提供的其他联系方式）、您与我们的沟通信息（包括文字/图片/音视频/通话记录形式）、与您需求相关联的其他必要信息</span>
            。我们收集这些信息是为了调查事实与帮助您解决问题，如您拒绝提供可能导致您无法使用我们的客服等用户响应功能。
          </div>
          <div class="line">
            当您使用在线客服沟通、意见反馈等的部分功能时，我们会请求您的
            <span class="boldT">相机、相册/存储权限</span>
            ，并收集您的
            <span class="boldT">图片信息</span>
            。若您拒绝提供的，仅会使您无法使用该功能，但并不影响您正常使用产品与/或服务的其他功能。
          </div>
          <div class="line"> 6、 活动参与</div>
          <div class="line">
            当您参与我们的活动，如抽奖、竞猜、答题、问卷调查时，我们可能会收集您的相关信息。例如：在您参与我们的游戏运营活动时，我们可能会收集您的
            <span class="boldT">账号信息、领取的福利信息、参与活动的记录</span>
            。
          </div>
          <div class="line"> 7、 其他功能</div>
          <div class="line">
            如果某一需要收集您的个人信息的功能未能在本规则中予以说明的，或者我们超出了收集您的个人信息时所声称的目的及具有直接或合理关联范围的，我们会再次向您告知，并根据法律法规的相关要求征得您的同意。
          </div>


          <div class="line">
            二、我们如何使用Cookie和同类技术
          </div>
          <div class="line">
            Cookie是包含字符串的小文件，在您登入和使用网站或其他网络内容时发送、存放在您的计算机、移动设备或其他装置内（通常经过加密）。Cookie同类技术是可用于与Cookie类似用途的其他技术，例如：Web
            Beacon、Proxy、嵌入式脚本等。
          </div>
          <div class="line">
            目前，我们主要使用Cookie收集您的个人信息。您知悉并同意，随着技术的发展和我们产品和服务的进一步完善，我们也可能会使用Cookie同类技术。
          </div>
          <div class="line">
            在您使用我们的产品与/或服务时，我们或我们合作伙伴可能会使用Cookie和同类技术收集您的一些个人信息，包括：您访问网站的习惯、您的浏览信息、您的登录信息，以便为您提供更优质的服务体验、保障服务安全。我们会严格要求第三方在本政策所述目的范围内使用Cookie和同类技术。
          </div>
          <div class="line">
            如果您的浏览器允许，您可以通过您的浏览器的设置以管理Cookie和同类技术。
            <span class="boldT">您理解并知悉：我们的某些产品与/或服务只能通过使用Cookie或同类技术才可得到实现，如您拒绝使用或删除的，您将可能无法获得我们的产品与/或服务的最佳的服务体验，同时也可能会对您的信息保护和账号安全性造成一定的影响</span>
            。
          </div>
          <div class="line">
            三、我们如何共享、转让、公开披露您的个人信息
          </div>
          <div class="line">
            1、 共享
          </div>
          <div class="line">
            我们在遵守“合法正当、最小必要、目的明确原则”的前提下共享您的个人信息。
          </div>
          <div class="line">
            如我们委托第三方处理您的个人信息的，我们将会与受托人约定委托处理的目的、期限、处理方式、个人信息的种类、保护措施以及双方的权利和义务等，并对受托人的个人信息处理活动进行监督。如果我们与第三方个人信息处理者共同决定您个人信息的处理目的和处理方式的，将与合作商约定各自的权利和义务，且该约定不影响您向其中任何一个个人信息处理者要求行使您的权利，若侵害您的个人信息权益造成损害的，我们将依法承担连带责任。
          </div>
          <div class="line">
            我们将对个人信息的共享活动事先进行个人信息保护影响评估，对输出形式、流转、使用等采取有效的技术保护措施。在合作协议层面，严格要求合作商的信息保护义务与责任，与业务合作商在合作前签署关于数据安全的保护协议。
          </div>
          <div class="line">
            • 实名认证服务：为遵守法律法规关于网络游戏实名认证的要求，使您顺利使用我们游戏产品与/或服务，我们会将您的
            <span class="boldT">姓名、身份证号实名信息</span>
            提交至国家新闻出版署网络游戏防沉迷实名验证系统进行真实身份验证。
          </div>
          <div class="line">
            • 支付服务：为保障交易安全、完成商品/服务的支付，我们会将您的
            <span class="boldT">订单支付相关信息</span>
            提供给提供支付服务的合作商（如支付宝、微信等机构）。
          </div>
          <div class="line">
            • 问题解决、纠纷处理：我们的产品服务等由我们与合作商共同提供或主要由合作商提供，如客户服务等，为解决您与我们及/或我们的合作商之间的投诉、纠纷等，我们可能在
            <span class="boldT">“最小必要”范围内向合作商提供解决问题、处理纠纷所需要的您的个人信息</span>
            。
          </div>
          <div class="line">
            • 在确保您的个人信息安全与目的正当的前提下，我们可能会向与我们合作的科研院所、高校等机构提供去标识化或匿名化的数据，用于相关领域的科研，促进科技发展。
          </div>
          <div class="line">
            • 我们接受尽职调查或审计时，与外部监管、专业咨询机构（如审计机构）等共享您的相关信息。
          </div>
          <div class="line">
            • 其他为实现我们的服务/功能所必需进行的共享。
          </div>
          <div class="line">
            2、 转让、公开披露
          </div>
          <div class="line">
            关于我们如何转让、公开披露您的个人信息，具体请见《四川繁羽开天科技有限公司游戏隐私政策》第三章节。
          </div>
          <div class="line">
            四、您对个人信息享有的控制权
          </div>
          <div class="line">
            我们非常重视您作为个人信息主体所享有的权利，并尽全力保护您对您的个人信息的控制权。在您使用四川繁羽开天科技有限公司游戏渠道服务时，为向您提供便捷查阅、修改/更正、删除您的个人信息的途径，同时保障您撤回同意的权利，我们在产品中设计了相关设置功能供您行使权利，您可以参考下方指引进行操作。
          </div>
          <div class="line">
            您可以在游戏内通过路径：【游戏个人中心】-【我的】查阅您的账号资本资料信息，如账号头像；
          </div>
          <div class="line">
            您可以在游戏内通过路径：【游戏个人中心】-【我的】-【账户安全】-【实名认证】查询与管理您的实名认证情况；
          </div>
          <div class="line">
            您可以在游戏内通过路径：【游戏个人中心】-【我的】-【账户安全】-【修改密码】修改您的账号密码；
          </div>
          <div class="line">
            您可以在游戏内通过路径：【游戏个人中心】-【我的】-【账户安全】-【注销账号】注销您的账号；
          </div>
          <div class="line">
            您还可以通过本规则第八节提供的联系方式联系我们以行使您的权利。
          </div>
          <div class="line">
            五、我们如何存储和保护您的个人信息
          </div>
          <div class="line">
            具体请参见《四川繁羽开天科技有限公司游戏隐私政策》第五章节。
          </div>
          <div class="line">
            六、未成年人保护
          </div>
          <div class="line">
            具体请参见《四川繁羽开天科技有限公司游戏隐私政策》第六章节。
          </div>
          <div class="line">
            七、本规则的更新
          </div>
          <div class="line">
            <span class="boldT">我们鼓励您在使用我们的产品或服务前仔细查阅我们的《四川繁羽开天科技有限公司游戏渠道SDK隐私规则》</span>
            。为了给您提供更好的服务，我们会根据产品的更新情况及法律法规的相关要求更新本规则的条款，该更新构成本规则的一部分。我们会通过站内信或其他适当的方式提醒您更新的内容，以便您及时了解本规则的最新版本。如该更新涉及重大变更，我们将在本规则生效前通过显著方式向您进行通知（如网站公示、弹窗方式）。但未经您明确同意，我们不会减损或侵害您依据本规则享有的个人权益。
          </div>
          <div class="line">
            八、如何联系我们
          </div>
          <div class="line">
            如您对本规则的执行或对我们的隐私保护相关事宜有任何投诉、建议、疑问，您可通过以下方式联系我们，我们会在验证您的用户身份后的15个工作日内向您回复：
          </div>
          <div class="line">
            1.专设的邮件通道：为更好地保护您的权益，我们专门设立了邮箱，您可以通过该邮箱与我们联系；
          </div>
          <div class="line">
            2.个人信息保护专员： 您可发送邮件至
            <a href="mailto:luyou@fanyukaitian.com.cn">luyou@fanyukaitian.com.cn</a>
            或写信至以下地址来与其联系：中国(四川)自由贸易试验区成都高新区梓州大道6900号6楼633号
          </div>
          <div class="line">
            法律部 个人信息保护专员（收）；邮编：610000；
          </div>
          <div class="line">
            3.在线客服通道：您可通过游戏产品功能页面的在线客服联系我们。
          </div>
        </div>

        <div class="section">
          <div class="line"> 四川繁羽开天科技有限公司</div>
        </div>


        <div class="section">
          <div class="boldT line">(九)其他功能</div>
          <div class="line">
            如果某一需要收集您的个人信息的功能或产品/服务未能在本政策中予以说明的，或者我们超出了与收集您的个人信息时所声称的目的及具有直接或合理关联范围的，我们会再次向您告知，并根据法律法规的相关要求征得您的同意。
          </div>
        </div>
        <div class="section">
          <div class="boldT line">例外情形</div>
          <div class="line">我们在以下情况下处理您的个人信息无需您的授权同意:</div>
          <div class="line">1.为订立、履行个人作为一方当事人的合同所必需,</div>
          <div class="line">2.为履行法定职责或者法定义务所必需;</div>
          <div class="line">
            3.为应对突发公共卫生事件，或者紧急情况下为保护自然人的生命健康和财产安全所必需;
          </div>
          <div class="line">4.为公共利益实施新闻报道、舆论监督等行为，在合理的范围内处理个人信息;</div>
          <div class="line">
            5.依照本法规定在合理的范围内处理个人自行公开或者其他已经合法公开的个人信息
          </div>
          <div class="line">6.法律、行政法规规定的其他情形。</div>
        </div>
        <div class="section">
          <div class="boldT line">二、我们如何使用Cookie和同类技术</div>
          <div class="line">
            Cookie是包含字符串的小文件，在您登入和使用网站或其他网络内容时发送、存放在您的计算机、移动设备或其他装置内(通常经过加密)。Cookie同类技术是可用于与Cookie类似用途的其他技术，例如:Web
            Beacon、Proxy、嵌入式脚本等。
          </div>
          <div class="line">
            目前，我们主要使用Cookie收集您的个人信息。您知悉并同意，随着技术的发展和我们产品和服务的进一步完善我们也可能会使用Cookie同类技术。
          </div>
          <div class="line">
            在您使用我们的产品与/或服务时，我们或我们合作伙伴等第三方可能会使用Cookie和同类技术收集您的一些个人信息，包括:您访问网站的习惯、您的浏览信息、您的登录信息，以便为您提供更优质的服务体验、保障服务安全。我们会严格要求第三方在本政策所述目的范围内使用Cookie和同类技术，明确约定合作伙伴无权将共享的个人信息用于任何其他用途，并告知合作伙伴需要履行对于个人信息的保密义务。
          </div>
          <div class="line">
            <span>如果您的浏览器允许，您可以通过您的浏览器的设置以管理Cookie和同类技术。</span>
            <span class="boldT">您理解并知悉:我们的某些产品与/或服务只能通过使用Cookie或同类技术才可得到实现，如您拒绝使用或删除的，您将可能无法获得我们的产品与/或服务的最佳的服务体验，同时也可能会对您的信息保护和账号安全性造成一定的影响。</span>
          </div>
        </div>
        <div class="section">
          <div class="boldT line">三、我们如何共享、转让、公开披露您的个人信息</div>
          <div class="boldT line">(一) 共享</div>
          <div class="line">我们在遵守“合法正当、最小必要、目的明确原则”及取得您的单独同意的前提下共享您的个人信息。
          </div>
          <div class="line">
            如我们委托第三方处理您的个人信息的，我们将会与受托人约定委托范围、委托处理的目的、期限、处理方式、个人信息的种类、保护措施以及双方的权利和义务等，并对受托人的个人信息处理活动进行监督。在委托合同不生效、无效、被撤销或者终止时，我们会要求受托方返还个人信息或者将个人信息予以删除，不得保留。
          </div>
          <div class="line">
            如果我们与第三方个人信息处理者共同决定您个人信息的处理目的和处理方式的，将与合作商约定各自的权利和义务，且该约定不影响您向其中任何一个个人信息处理者要求行使您的权利，且发生若侵害您的个人信息权益造成损害的，我们将依法承担连带责任。
          </div>
          <div class="line">
            我们将对个人信息的共享活动事先进行个人信息保护影响评估，对输出形式、流转、使用等采取有效的技术保护措施。在合作协议层面，严格要求合作商的信息保护义务与责任，与业务合作商在合作前签署关于数据安全的保护协议。
          </div>
          <div class="boldT line">1. 我们的合作商</div>
          <div class="line">
            <span>1)实名认证服务:为遵守法律法规关于网络游戏实名认证的要求，使您顺利使用我们相关产品与/或服务，我们会将您的</span>
            <span class="boldT">姓名、身份证号实名信息</span>
            <span>提交至国家新闻出版署网络游戏防沉迷实名验证系统进行真实身份验证</span>
          </div>
          <div class="line">
            <span>2)支付服务:为保障交易安全、完成商品/服务的支付，我们会将您的</span>
            <span class="boldT">订单支付相关信息</span>
            <span>提供给提供支付服务的合作商。</span>
          </div>
          <div class="line">
            <span>3)市场营销:我们会在第三方平台向您展示我们的部分游戏产品与/或服务。为了更好的向您展示我们的内容、评估市场营销效果等目的，我们需要向第三方服务平台共享您的部分数据，包括</span>
            <span class="boldT">设备标识信息、QQ号。</span>
          </div>
          <div class="line">
            <span>4)问题解决、纠纷处理:我们平台的部分活动/产品服务等由我们与合作商共同提供或主要由合作商提供，为解决您与我们及/或我们的合作商之间的投诉、纠纷等，我们可能在</span>
            <span class="boldT">“最小必要“范围内向合作商提供解决问题、处理纠纷所需要的您的个人信息。</span>
          </div>
          <div class="line">
            5）代理发行:如果您使用我们代理发行的游戏产品，我们可能与开发主体或相关第三方共享您在游戏中产生的游戏日志及相关信息(如崩溃日志等)，用于游戏安全分析，完善游戏服务，进一步优化您的游戏体验。
          </div>
          <div class="line">
            6）.在确保您的个人信息安全与目的正当的前提下，我们可能会向与我们合作的科研院所、高校等机构提供去标识化或匿名化的数据，用于相关领域的科研，促进科技发展。
          </div>
          <div class="line">7）我们接受尽职调查或审计时，与外部监管、专业咨询机构(如审计机构)等共享您的相关信息。
          </div>
          <div class="line">8）其他为实现我们的服务/功能所必需进行的共享。</div>
        </div>
        <div class="section">
          <div class="boldT line">2.关联APP</div>
          <div class="line">
            <span>为便于我们向您提供一致化服务、完善用户体验、实现安全风控、提供客户服务之需要，功能有相应联系的关联App将适用统一账号体系。适用统一账号体系的关联公司App将同步您注册、登录、使用我们的产品与/或服务的些个人信息，主要包括</span>
            <span class="boldT">:(1)您的设备信息;(2)您的基本资料信息，如头像等。</span>
          </div>
          <div class="line">注:</div>
          <div class="line">
            “统一账号体系“指,对您在关联App中绑定的手机号码，创建统一的字符串，实现账号统一登录，并获得相关功能
          </div>
          <div class="boldT line">3.第三方SDK类服务商</div>
          <div class="line">
            为保障我们的客户端的稳定运行、功能实现，使您能够使用和享受更多的服务及功能，我们的应用中会嵌入业务合作商的软件工具开发包(SDK)或其他类似的应用程序。我们会对业务合作商获取信息的SDK、应用程序接口(API)进行严格的安全监测，令其按照本政策以及其他任何相关的保密和安全措施来处理个人信息，以保障数据安全。
          </div>
          <div class="line">TapADN广告组件、ThinkingAnalyticsSDK、Unity3D 游戏引擎库获取了Android ID。查看
            <a href="https://kl3g96a53c.feishu.cn/docx/UHjqdy6EboyP69x7IeBc9zwOnyp">四川繁羽开天科技有限公司游戏第三方SDK类服务商</a>
            进一步了解。
          </div>
        </div>


        <div class="section">
          <div class="line">
            《四川繁羽开天科技有限公司游戏第三方SDK类服务商》
          </div>
          <div class="line">
            为保障四川繁羽开天科技有限公司游戏产品中相关功能的实现与应用安全稳定的运行，我们可能会接入由第三方提供的软件工具开发包（SDK）实现相关目的。
          </div>
          <div class="line">
            我们会对合作方获取信息的软件工具开发包（SDK）进行严格的安全监测，以保护数据安全。我们可能会接入以下全部或部分第三方软件工具开发包（SDK）。
          </div>
          <div class="line">

          </div>
          <div class="line">
            一、iOS端
          </div>
          <div class="line">
            1、SDK名称：QQ SDK
          </div>
          <div class="line">
            第三方公司名称：腾讯科技（深圳）有限公司
          </div>
          <div class="line">
            共享信息名称：无使用目的：第三方授权登录、内容分享
          </div>
          <div class="line">
            使用场景：用户使用QQ账号授权登录；用户分享内容至QQ客户端时权限调用：不涉及
          </div>
          <div class="line">
            共享方式：不共享数据
          </div>
          <div class="line">
            第三方隐私链接：<a href="https://wiki.connect.qq.com/">https://wiki.connect.qq.com/</a>
          </div>
          <div class="line">

          </div>
          <div class="line">
            2、SDK名称：微信
          </div>
          <div class="line">
            SDK第三方公司名称：深圳市腾讯计算机系统有限公司共享信息名称：无使用目的：第三方授权登录、内容分享使用场景：用户使用微信账号授权登录时；用户分享内容至微信客户端时权限调用：不涉及
          </div>
          <div class="line">
            共享方式：不共享数据
          </div>
          <div class="line">
            第三方隐私链接：<a
              href="https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8">https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8</a>
          </div>
          <div class="line">

          </div>
          <div class="line">
            3、SDK名称：讯飞SDK第三方公司名称：科大讯飞股份有限公司共享信息名称：设备标识信息、音频流数据、网络相关信息（网络运营商、基站位置）、应用安装列表、当前运行应用进程使用目的：用于提供游戏内语音转文字功能使用场景：发送语音聊天时
          </div>
          <div class="line">
            权限调用：不涉及共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a href="https://www.xfyun.cn/doc/policy/privacy.html">https://www.xfyun.cn/doc/policy/privacy.html</a>
          </div>
          <div class="line">

          </div>
          <div class="line">
            4、SDK名称：腾讯Bugly SDK
          </div>
          <div class="line">
            第三方公司名称：深圳市腾讯计算机系统有限公司
          </div>
          <div class="line">
            共享信息名称：设备标识信息、设备参数及系统信息、系统属性、应用特征信息、使用数据
          </div>
          <div class="line">
            使用目的：用于收集游戏运行时的异常日志
          </div>
          <div class="line">
            使用场景：游戏上报错误或崩溃日志时
          </div>
          <div class="line">
            权限调用：不涉及
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a href="https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56">https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56</a>
          </div>
          <div class="line">

          </div>
          <div class="line">
            5、SDK名称：数字联盟可信 ID
          </div>
          <div class="line">
            第三方公司名称：北京数字联盟网络科技有限公司共享信息名称：设备制造商、设备型号、设备系统版本、应用版本、IDFA、IDFV、设备网络状况信息及其他设备物理环境信息。使用目的：用于安全风控，设备有效性检测，防止作弊和欺诈，维护用户合法权益，保障移动互联网安全。使用场景：检测设备欺诈与作弊行为，识别反馈设备的真实性权限调用：不涉及
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a href="https://www.shuzilm.cn/privacy.html">https://www.shuzilm.cn/privacy.html</a>
          </div>
          <div class="line">

          </div>
          <div class="line">
            6、SDK名称：Tracking IO SDK
          </div>
          <div class="line">
            第三方公司名称：北京热云科技有限公司共享信息名称：设备标识信息（IDFA、IDFV、网卡地址（Mac））、设备参数及系统信息（设备型号、设备厂商、操作系统版本）、运行环境、IP地址、交易金额使用目的：用于安全风控，防止作弊和欺诈；广告监测与归因，优化广告投放策略；提供用户画像分析服务使用场景：向用户推荐广告、用户点击广告时权限调用：不涉及
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a href="https://new.trackingio.com/#/policy">https://new.trackingio.com/#/policy</a>
          </div>
          <div class="line">

          </div>
          <div class="line">
            二、Android端
          </div>
          <div class="line">
            1、SDK名称：QQ SDK
          </div>
          <div class="line">
            第三方公司名称：腾讯科技（深圳）有限公司
          </div>
          <div class="line">
            共享信息名称：设备标识信息（Android ID、Device ID、ICCID、Mac地址）、QQ/Tim/
          </div>
          <div class="line">
            QQ极速版的安装信息、应用安装列表、设备参数及系统信息（设备型号、操作系统、操作系统版本）
          </div>
          <div class="line">
            使用目的：第三方授权登录、内容分享
          </div>
          <div class="line">
            使用场景：用户使用QQ账号授权登录；用户分享内容至QQ客户端时
          </div>
          <div class="line">
            权限调用：不涉及
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a href="https://wiki.connect.qq.com/qq">https://wiki.connect.qq.com/qq</a> 互联sdk隐私保护声明
          </div>
          <div class="line">

          </div>
          <div class="line">
            2、SDK名称：微信 SDK
          </div>
          <div class="line">
            第三方公司名称：深圳市腾讯计算机系统有限公司
          </div>
          <div class="line">
            共享信息名称：设备标识信息（Android ID）、设备参数及系统信息（设备型号、操作系统）、网络相关信息（IP地址、网络运营商）
          </div>
          <div class="line">
            使用目的：第三方授权登录、内容分享
          </div>
          <div class="line">
            使用场景：用户使用微信账号授权登录时；用户分享内容至微信客户端时
          </div>
          <div class="line">
            权限调用：不涉及
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a
              href="https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8">https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8</a>
          </div>
          <div class="line">

          </div>
          <div class="line">
            3、SDK名称：微信支付 SDK
          </div>
          <div class="line">
            第三方公司名称：财付通支付科技有限公司
          </div>
          <div class="line">
            共享信息名称：设备标识信息（Android ID）、设备参数及系统信息（设备型号、操作系统）、网络相关信息（网络运营商、IP地址）
          </div>
          <div class="line">
            使用目的：帮助用户在应用内完成支付
          </div>
          <div class="line">
            使用场景：用户使用微信支付时
          </div>
          <div class="line">
            权限调用：不涉及
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a
              href="https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8">https://support.weixin.qq.com/cgi-bin/mmsupportacctnodeweb-bin/pages/RYiYJkLOrQwu0nb8</a>
          </div>
          <div class="line">

          </div>
          <div class="line">
            4、SDK名称：Alipay（支付宝）第三方公司名称：支付宝（中国）网络技术有限公司共享信息名称：设备标识信息（IMEI、IMSI、SIM卡序列号、Android
          </div>
          <div class="line">
            ID、ICCID
          </div>
          <div class="line">
            、Mac地址）、网络相关信息（网络类型、状态、网络运营商、WLAN接入点（SSID、BSSID））、设备参数及系统信息（硬件序列号、设备名称、设备型号、手机制造商、操作系统、操作系统版本、系统语言）使用目的：帮助用户在应用内完成支付使用场景：用户使用支付宝支付时权限调用：不涉及
          </div>
          <div class="line">
            共享方式：SDK本机收集
          </div>
          <div class="line">
            第三方隐私链接：<a href="https://opendocs.alipay.com/open/54/01g6qm">https://opendocs.alipay.com/open/54/01g6qm</a>
          </div>
          <div class="line">

          </div>
          <div class="line">
            5、SDK名称：讯飞SDK第三方公司名称：科大讯飞股份有限公司共享信息名称：设备标识信息（IMSI、Mac地址、Android
          </div>
          <div class="line">
            ID）、音频流数据、网络相关信息（网络运营商、基站位置）、应用安装列表、当前运行应用进程使用目的：用于提供游戏内语音转文字功能使用场景：发送语音聊天时权限调用：不涉及
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a href="https://www.xfyun.cn/doc/policy/privacy.html">https://www.xfyun.cn/doc/policy/privacy.html</a>
          </div>
          <div class="line">

          </div>
          <div class="line">
            6、SDK名称：腾讯Bugly SDK
          </div>
          <div class="line">
            第三方公司名称：深圳市腾讯计算机系统有限公司
          </div>
          <div class="line">
            共享信息名称：设备标识信息（IMSI、Mac地址、Android ID）、设备参数及系统信息、系统属性、网络状态信息、系统底层日志
          </div>
          <div class="line">
            使用目的：用于收集游戏运行时的异常日志
          </div>
          <div class="line">
            使用场景：游戏上报错误或崩溃日志时
          </div>
          <div class="line">
            权限调用：不涉及
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a href="https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56">https://privacy.qq.com/document/preview/fc748b3d96224fdb825ea79e132c1a56</a>
          </div>
          <div class="line">

          </div>
          <div class="line">
            7、SDK名称：Quick SDK
          </div>
          <div class="line">
            第三方公司名称： 成都惜东网络科技有限公司
          </div>
          <div class="line">
            共享信息名称：设备标识信息(OAID、IMEI、MEID、IMSI、Android
          </div>
          <div class="line">
            ID、Mac地址)、设备参数及系统信息（设备序列号）、应用特征信息（版本号、运行中的进程）、SIM卡信息、SD卡数据、网络相关信息（IP地址）
          </div>
          <div class="line">
            使用目的：聚合分发渠道、使用情况统计
          </div>
          <div class="line">
            使用场景：用户通过集成的渠道SDK进行账号登录、实名、支付及咨询客服时，为了保证您的账号安全，在游戏加载异常时进行异常处理重新加载，可能会自启动或者关联自启动。
          </div>
          <div class="line">
            权限调用：不涉及共享方式：SDK本机采集(com.quickgamesdk.utils,com.fairytail.sdkconnector,com.quickgamesdk.manager,com.quickgamesdk.QGManager,com.quickgamesdk.adplus,com.quickgamesdk.fragment,com.quickgamesdk.activity,com.quickgamesdk.skin,
          </div>
          <div class="line">
            com.quickgamesdk.gamebox)
          </div>
          <div class="line">
            第三方隐私链接：<a href="https://www.quicksdk.com/base/agreenment/f/private">https://www.quicksdk.com/base/agreenment/f/private</a>
          </div>
          <div class="line">

          </div>
          <div class="line">
            8、SDK名称：字节增长营销SDK
          </div>
          <div class="line">
            第三方公司名称：北京微播视界科技有限公司
          </div>
          <div class="line">
            共享信息名称：设备标识信息（IMEI、Android
          </div>
          <div class="line">
            ID、OAID、IMSI、ICCID、GAID、MEID、Mac地址）、设备参数及系统信息（硬件型号、硬件序列号、操作系统版本号）、网络相关信息（IP地址、WLAN接入点（如SSID、BSSID）、SIM卡信息、基站、网络接入方式、类型、状态、网络质量数据）、蓝牙（Bluetooth）、应用特征信息（软件版本号、运行中的进程）、操作、使用、服务日志、传感器信息等
          </div>
          <div class="line">
            使用目的：用于广告监测与归因、分析、衡量广告和相关服务的有效性、进行广告或决策建议、提高广告有效触达率
          </div>
          <div class="line">
            使用场景：用户下载并使用游戏产品时
          </div>
          <div class="line">
            权限调用：不涉及共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a
              href="https://sf3-cdn-tos.douyinstatic.com/obj/ies-hotsoon-draft/douyin_agreement/privacy.html?">https://sf3-cdn-tos.douyinstatic.com/obj/ies-hotsoon-draft/douyin_agreement/privacy.html?</a>
          </div>
          <div class="line">

          </div>
          <div class="line">
            9、SDK名称： 巨量引擎转化SDK第三方公司名称： 北京巨量引擎网络技术有限公司共享信息名称：设备标识信息（Android
          </div>
          <div class="line">
            ID、OAID、IMEI、MEID）、设备参数及系统信息（设备品牌、型号、硬件序列号、系统属性、操作系统等）、应用特征信息（应用版本）、SIM卡等
          </div>
          <div class="line">
            使用目的：用于广告监测与归因、分析、衡量广告和相关服务的有效性、进行广告或决策建议、提高广告有效触达率
          </div>
          <div class="line">
            使用场景：用户下载并使用游戏产品时
          </div>
          <div class="line">
            权限调用：不涉及共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a href="https://open.oceanengine.com/labels/7/docs/1708428054592516">https://open.oceanengine.com/labels/7/docs/1708428054592516</a>
          </div>
          <div class="line">

          </div>
          <div class="line">
            10、SDK名称： 数数科技SDK第三方公司名称：数数信息科技(上海)有限公司 共享信息名称：IP
          </div>
          <div class="line">
            地址、国家、国家代码、省份、城市、操作系统版本、设备制造商、操作系统、设备 ID、设备型号、App
          </div>
          <div class="line">
            版本、应用唯一标识、SDK
          </div>
          <div class="line">
            类型、SDK 版本、网络状态、网络运营商、运行中的进程等
          </div>
          <div class="line">
            使用目的：用于用户数据分析，了解产品的使用情况、提供分析服务并输出分析结果，以改善产品质量。
          </div>
          <div class="line">
            使用场景：用户下载并使用游戏产品时
          </div>
          <div class="line">
            权限调用：不涉及共享方式：SDK本机采集（ThinkingAnalyticsSDK）
          </div>
          <div class="line">
            第三方隐私链接：<a href="https://docs.thinkingdata.cn/ta-manual/latest/user_guide/privacy_policy.html">https://docs.thinkingdata.cn/ta-manual/latest/user_guide/privacy_policy.html</a>
          </div>
          <div class="line">

          </div>
          <div class="line">
            11、SDK名称：
          </div>
          <div class="line">
            阿里云认证SDK第三方公司名称：阿里云计算有限公司共享信息名称：网络类型、切换wifi和蜂窝网络通道、设备信息（含IP地址、设备制造商、设备型号、手机操作系统、SIM卡信息SIM
          </div>
          <div class="line">
            State、SIM卡信息ICCID、IMSI）等
          </div>
          <div class="line">
            使用目的：用于用户使用手机号一键登录。
          </div>
          <div class="line">
            使用场景：用户使用阿里云一键登录时使用
          </div>
          <div class="line">
            权限调用：不涉及共享方式：SDK本机采集（com.nirvana.tools,com.mobile.auth）
          </div>
          <div class="line">
            第三方隐私链接：<a
              href="https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112211045_86198.html?spm=a2c4g.11186623.0.0.3bff633eG5zqm">https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112211045_86198.html?spm=a2c4g.11186623.0.0.3bff633eG5zqm</a>
          </div>
          <div class="line">

          </div>
          <div class="line">
            12、SDK名称：TEST+崩溃监控分析SDK第三方公司名称：成都西山居世游科技有限公司共享信息名称：设备标识信息（IMSI、Mac地址、Android
          </div>
          <div class="line">
            ID）、设备参数及系统信息、系统属性、网络状态信息、运行中的进程等
          </div>
          <div class="line">
            使用目的：用于收集程序崩溃信息。
          </div>
          <div class="line">
            使用场景：游戏上报错误或崩溃日志时
          </div>
          <div class="line">
            权限调用：不涉及
          </div>
          <div class="line">
            共享方式：SDK本机采集（com.xsj.crasheye）
          </div>
          <div class="line">
            第三方隐私链接：<a href="http://www.testplus.cn/privacy">http://www.testplus.cn/privacy</a>
          </div>
          <div class="line">

          </div>
          <div class="line">
            13、SDK名称：Tracking IO SDK
          </div>
          <div class="line">
            第三方公司名称：北京热云科技有限公司共享信息名称：设备标识信息（Android
          </div>
          <div class="line">
            ID、IMEI、MEID、OAID、网卡地址（Mac））、设备参数及系统信息（设备型号、设备厂商、操作系统版本）、运行环境、IP地址、交易金额使用目的：用于安全风控，防止作弊和欺诈；广告监测与归因，优化广告投放策略；提供用户画像分析服务
          </div>
          <div class="line">
            使用场景：向用户推荐广告、用户点击广告时
          </div>
          <div class="line">
            权限调用：不涉及
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a href="https://new.trackingio.com/#/policy">https://new.trackingio.com/#/policy</a>
          </div>
          <div class="line">

          </div>
          <div class="line">
            14、SDK名称：Unity3D
          </div>
          <div class="line">
            第三方公司名称：易玩（上海）网络科技有限公司
          </div>
          <div class="line">
            共享信息名称：用户的设备信息（包括设备型号、操作系统版本、唯一设备标识符）、用户的游戏行为数据（如游戏时长、得分、操作记录）
          </div>
          <div class="line">
            使用目的：用于优化游戏性能、改进用户体验、进行数据分析以提供更符合用户需求的内容和服务。
          </div>
          <div class="line">
            使用场景：在游戏的后台服务器进行数据处理和分析，以评估游戏的表现和用户行为模式。
          </div>
          <div class="line">
            权限调用：不涉及
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a href="https://unity.com/cn/legal/privacy-policy">https://unity.com/cn/legal/privacy-policy</a>
          </div>
          <div class="line">

          </div>
          <div class="line">
            15、SDK名称：联通认证
          </div>
          <div class="line">
            第三方公司名称：联通在线信息科技有限公司
          </div>
          <div class="line">
            共享信息名称：用户联通手机号、设备基础信息（如设备型号、系统版本）、网络状态信息
          </div>
          <div class="line">
            使用目的：为游戏提供联通手机号快捷登录及身份验证服务，简化用户登录流程，确保登录身份真实性
          </div>
          <div class="line">
            使用场景：用户在游戏登录界面选择 “联通手机号快捷登录” 时，用于完成手机号验证及账号登录操作
          </div>
          <div class="line">
            权限调用：不涉及
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a href="https://msv6.wosms.cn/html/oauth/protocol2.html">https://msv6.wosms.cn/html/oauth/protocol2.html</a>
          </div>
          <div class="line">

          </div>
          <div class="line">
            16、SDK名称：移动智能终端补充设备标识体系统一调用
          </div>
          <div class="line">
            第三方公司名称：联通在线信息科技有限公司
          </div>
          <div class="line">
            共享信息名称：设备合规标识信息（如 OAID、VAID、AAID 等，依据移动智能终端补充设备标识体系规范）、设备基础信息（如设备型号、系统版本）
          </div>
          <div class="line">
            使用目的：在合规范围内获取设备标识，用于游戏用户行为统计分析、运营数据统计及广告投放合规性支持
          </div>
          <div class="line">
            使用场景：游戏运行过程中，需统计用户活跃数据、设备关联信息时，或对接广告服务需提供合规设备标识时调用
          </div>
          <div class="line">
            权限调用：不涉及
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a href="https://www.msa-alliance.cn/col.jsp?id=122">https://www.msa-alliance.cn/col.jsp?id=122</a>
          </div>
          <div class="line">

          </div>
          <div class="line">
            17、SDK名称：鲸鸿动能SDK
          </div>
          <div class="line">
            第三方公司名称：华为软件技术有限公司
          </div>
          <div class="line">
            共享信息名称：设备基础信息（如设备型号、系统版本、网络状态）、用户游戏内行为数据（如广告点击、广告停留时长、游戏内页面浏览路径）
          </div>
          <div class="line">
            使用目的：为游戏提供广告展示、广告投放及流量变现服务，优化广告展示效果，提升游戏商业化收益
          </div>
          <div class="line">
            使用场景：游戏内展示激励视频广告、插屏广告、横幅广告等场景，用于广告加载、展示及效果统计
          </div>
          <div class="line">
            权限调用：不涉及
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a
              href="https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/whale-hong-kinetic-energy-sdk-privacy-statement-0000001658283582">https://developer.huawei.com/consumer/cn/doc/HMSCore-Guides/whale-hong-kinetic-energy-sdk-privacy-statement-0000001658283582</a>
          </div>
          <div class="line">

          </div>
          <div class="line">
            18、SDK名称：QuickGame 自发行SDK
          </div>
          <div class="line">
            第三方公司名称：成都惜东网络科技有限公司
          </div>
          <div class="line">
            共享信息名称：设备基础信息（如设备型号、系统版本、唯一设备标识符）、游戏运行数据（如安装时间、启动次数、停留时长、关卡进度）、用户操作行为（如按钮点击、功能使用记录）
          </div>
          <div class="line">
            使用目的：支持游戏自发行过程中的数据统计、用户行为分析及渠道运营管理，优化游戏发行策略
          </div>
          <div class="line">
            使用场景：游戏安装后首次启动、用户日常登录游戏、进行关卡挑战等操作时，用于记录并分析用户行为及游戏运营数据
          </div>
          <div class="line">
            权限调用：不涉及
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a href="https://www.quicksdk.com/base/agreenment/f/private">https://www.quicksdk.com/base/agreenment/f/private</a>
          </div>
          <div class="line">

          </div>
          <div class="line">
            19、SDK名称：微博移动
          </div>
          <div class="line">
            第三方公司名称：北京微梦创科网络技术有限公司
          </div>
          <div class="line">
            共享信息名称：用户微博账号基本信息（如微博昵称、头像、用户
          </div>
          <div class="line">
            ID）、游戏内分享内容（如游戏成就截图、文字描述）、设备基础信息（如设备型号、系统版本）
          </div>
          <div class="line">
            使用目的：为游戏提供微博账号快捷登录及游戏内容分享功能，降低登录门槛，提升游戏社交传播性
          </div>
          <div class="line">
            使用场景：用户在游戏登录界面选择 “微博登录” 时，或在游戏内通过 “分享到微博” 功能分享游戏成就、截图时调用
          </div>
          <div class="line">
            权限调用：不涉及
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a
              href="https://open.weibo.com/wiki/Sdk/privacy">https://open.weibo.com/wiki/Sdk/privacy</a>
          </div>
          <div class="line">

          </div>
          <div class="line">
            20、SDK名称：LeanCloud Java SDK
          </div>
          <div class="line">
            第三方公司名称：美味书签（北京）信息技术有限公司
          </div>
          <div class="line">
            共享信息名称：游戏用户数据（如角色 ID、角色等级、装备信息、游戏进度）、用户操作记录（如任务完成状态、充值记录）、设备基础信息（如设备型号、系统版本）
          </div>
          <div class="line">
            使用目的：为游戏提供后端数据存储、实时数据同步及玩家交互支持，保障游戏数据稳定存储及玩家间实时互动功能实现
          </div>
          <div class="line">
            使用场景：游戏内用户角色数据（如等级、装备）的存储与同步、玩家间实时聊天 / 组队信息交互、游戏任务进度记录等场景
          </div>
          <div class="line">
            权限调用：不涉及
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a href="https://www.leancloud.cn/privacy/sdk-data-collection/android/">https://www.leancloud.cn/privacy/sdk-data-collection/android/</a>
          </div>
          <div class="line">

          </div>
          <div class="line">
            21、SDK名称：号码认证-android
          </div>
          <div class="line">
            第三方公司名称：阿里巴巴云计算（北京）有限公司
          </div>
          <div class="line">
            共享信息名称：用户本机手机号（用于认证）、设备基础信息（如设备型号、系统版本、设备标识符）、网络状态信息（如网络类型、信号强度）
          </div>
          <div class="line">
            使用目的：为游戏提供手机号快捷登录及身份核验服务，通过本机号码自动校验，简化用户登录流程，减少手动输入操作，同时确保登录身份的真实性，防范恶意注册或登录风险
          </div>
          <div class="line">
            使用场景：用户在游戏登录界面选择 “本机号码一键登录” 时，SDK
          </div>
          <div class="line">
            通过本机环境校验用户手机号合法性，完成身份验证并实现快速登录，无需用户手动输入手机号及验证码
          </div>
          <div class="line">
            权限调用：不涉及
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a
              href="https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112211045_86198.html?spm=a2c4g.11186623.0.0.727039eb0HflH4">https://terms.aliyun.com/legal-agreement/terms/suit_bu1_ali_cloud/suit_bu1_ali_cloud202112211045_86198.html?spm=a2c4g.11186623.0.0.727039eb0HflH4</a>
          </div>

          <div class="line">
            22、电信SDK
          </div>
          <div class="line">
            涉及个人信息：Android ID、IMEI、IMSI、IP地址、手机号码
          </div>
          <div class="line">
            使用目的：用于阿里云手机号码一键登录
          </div>
          <div class="line">
            公司主体名称：世纪龙信息网络有限责任公司
          </div>
          <div class="line">
            收集方式：SDK采集
          </div>
          <div class="line">
            官网链接：
            <a href="https://e.dlife.cn/index.do">https://e.dlife.cn/index.do</a>
          </div>
          <div class="line">
            隐私政策：
            <a href="https://e.189.cn/sdk/agreement/show.do?order=2&type=main&appKey=E_189&hidetop=true&isShowPre=&returnUrl=https%3A%2F%2Fe.dlife.cn">https://e.189.cn/sdk/agreement/show.do?order=2&type=main&appKey=E_189&hidetop=true&isShowPre=&returnUrl=https%3A%2F%2Fe.dlife.cn</a>
          </div>
          <div class="line">

          </div>
          <div class="line">
            23、联通认证SDK
          </div>
          <div class="line">
            涉及个人信息：Android ID、IMEI、IMSI、IP地址、手机号码
          </div>
          <div class="line">
            使用目的：用于阿里云手机号码一键登录
          </div>
          <div class="line">
            公司主体名称：中国联合网络通信有限公司北京市分公司/小沃科技有限公司
          </div>
          <div class="line">
            收集方式：SDK采集
          </div>
          <div class="line">
            官网链接：
            <a href="http://www.chinaunicom.com.cn/">http://www.chinaunicom.com.cn/</a>
          </div>
          <div class="line">
            隐私政策：
            <a href="https://opencloud.wostore.cn/authz/resource/html/disclaimer.html?spm=a2c4g.11186623.0.0.41f1633eHxMLkQ&fromsdk=true">https://opencloud.wostore.cn/authz/resource/html/disclaimer.html?spm=a2c4g.11186623.0.0.41f1633eHxMLkQ&fromsdk=true</a>
          </div>
          <div class="line">

          </div>
          <div class="line">
            24、QuickAD广告追踪SDK
          </div>
          <div class="line">
            涉及个人信息：device_os_v系统版本、OAID
          </div>
          <div class="line">
            使用目的：广告数据监测和投放
          </div>
          <div class="line">
            公司主体名称：成都惜东网络科技有限公司
          </div>
          <div class="line">
            收集方式：SDK采集
          </div>
          <div class="line">
            官网链接：<a href="https://www.quicksdk.com/index.html">https://www.quicksdk.com/index.html</a>
          </div>
          <div class="line">
            隐私政策：<a href="https://www.quicksdk.com/base/agreenment/f/private">https://www.quicksdk.com/base/agreenment/f/private</a>
          </div>
          <div class="line">

          </div>
          <div class="line">
            25、Quick云客服SDK
          </div>
          <div class="line">
            涉及个人信息：WIFI、系统语言、系统版本、剩余内存、总内存、ANDROIDID、SerialNum、摄像头权限、相册权限、读写权限
          </div>
          <div class="line">
            使用目的：用于客服与客户间沟通交流
          </div>
          <div class="line">
            公司主体名称：成都惜东网络科技有限公司
          </div>
          <div class="line">
            收集方式：SDK采集
          </div>
          <div class="line">
            官网链接：<a href="https://www.quicksdk.com/index.html">https://www.quicksdk.com/index.html</a>
          </div>
          <div class="line">
            隐私政策：<a href="https://www.quicksdk.com/base/agreenment/f/private">https://www.quicksdk.com/base/agreenment/f/private</a>
          </div>
          <div class="line">

          </div>
          <div class="line">
            26、七牛qiniuSDK
          </div>
          <div class="line">
            涉及个人信息：Android ID、IMEI、MEID
          </div>
          <div class="line">
            使用目的：用于云客服图⽚、⾳频上传
          </div>
          <div class="line">
            公司主体名称：上海七牛信息技术有限公司
          </div>
          <div class="line">
            收集方式：SDK采集
          </div>
          <div class="line">
            官网链接：<a href="https://www.qiniu.com/">https://www.qiniu.com/</a>
          </div>
          <div class="line">
            隐私政策：<a href="https://www.qiniu.com/agreements/privacy-right">https://www.qiniu.com/agreements/privacy-right</a>
          </div>
          <div class="line">

          </div>
          <div class="line">
            27、百度oCPC SDK
          </div>
          <div class="line">
            涉及个人信息：Android ID、IMEI、OAID
          </div>
          <div class="line">
            使用目的：广告数据监测和投放
          </div>
          <div class="line">
            公司主体名称：北京百度网讯科技有限公司
          </div>
          <div class="line">
            收集方式：SDK采集
          </div>
          <div class="line">
            官网链接：<a href="https://dev2.baidu.com/home">https://dev2.baidu.com/home</a>
          </div>
          <div class="line">
            隐私政策：<a
              href="https://ocpx-devcenter.bj.bcebos.com/videoworks/console-upload/%E3%80%90%E7%99%BE%E5%BA%A6oCPX%E5%BA%94%E7%94%A8SDK%E8%BD%AC%E5%8C%96%E8%BF%BD%E8%B8%AA%E5%B7%A5%E5%85%B7%E3%80%91%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96.pdf?authorization=bce-auth-v1/e2ea496b5e7f4e20bd0e5d1ce5533588/2022-03-02T07%3A26%3A49Z/-1/host/a457d9fc218b82a94f1a1209ed821931c1f7703ffe40bd220ba25ce5e42f8056">https://ocpx-devcenter.bj.bcebos.com/videoworks/console-upload/%E3%80%90%E7%99%BE%E5%BA%A6oCPX%E5%BA%94%E7%94%A8SDK%E8%BD%AC%E5%8C%96%E8%BF%BD%E8%B8%AA%E5%B7%A5%E5%85%B7%E3%80%91%E9%9A%90%E7%A7%81%E6%94%BF%E7%AD%96.pdf?authorization=bce-auth-v1/e2ea496b5e7f4e20bd0e5d1ce5533588/2022-03-02T07%3A26%3A49Z/-1/host/a457d9fc218b82a94f1a1209ed821931c1f7703ffe40bd220ba25ce5e42f8056</a>
          </div>
          <div class="line">

          </div>
          <div class="line">
            28、广点通SDK
          </div>
          <div class="line">
            涉及个人信息：Android ID、IMEI、MEID、OAID、MAC
          </div>
          <div class="line">
            使用目的：广告数据监测和投放
          </div>
          <div class="line">
            公司主体名称：深圳市腾讯计算机系统有限公司
          </div>
          <div class="line">
            收集方式：SDK采集
          </div>
          <div class="line">
            官网链接：<a href="https://datanexus.qq.com/">https://datanexus.qq.com/</a>
          </div>
          <div class="line">
            隐私政策：<a href="https://datanexus.qq.com/doc/develop/compliance/android/privacy_policy">https://datanexus.qq.com/doc/develop/compliance/android/privacy_policy</a>
          </div>
          <div class="line">

          </div>
          <div class="line">
            29、热力引擎SDK
          </div>
          <div class="line">
            涉及个人信息：Android ID、IMEI、MEID、OAID
          </div>
          <div class="line">
            使用目的：广告数据监测和投放
          </div>
          <div class="line">
            公司主体名称：汇量云(北京)科技有限公司
          </div>
          <div class="line">
            收集方式：SDK采集
          </div>
          <div class="line">
            官网链接：<a href="https://www.solar-engine.com/cn/">https://www.solar-engine.com/cn/</a>
          </div>
          <div class="line">
            隐私政策：<a href="https://www.solar-engine.com/privacyPolicy.html">https://www.solar-engine.com/privacyPolicy.html</a>
          </div>
          <div class="line">

          </div>
          <div class="line">
            30、UC阿里汇川SDK
          </div>
          <div class="line">
            涉及个人信息：Android ID、IMEI、MEID、OAID
          </div>
          <div class="line">
            使用目的：广告数据监测和投放
          </div>
          <div class="line">
            公司主体名称：广州市动景计算机科技有限公司
          </div>
          <div class="line">
            收集方式：SDK采集
          </div>
          <div class="line">
            官网链接：<a href="https://sso.uc.cn/sso/static/pages/v2/hcsso.html">https://sso.uc.cn/sso/static/pages/v2/hcsso.html</a>
          </div>
          <div class="line">
            隐私政策：<a href="https://www.uc.cn/about/privacy/#about-content">https://www.uc.cn/about/privacy/#about-content</a>
          </div>
          <div class="line">

          </div>
          <div class="line">
            31、TapTap数据统计SDK
          </div>
          <div class="line">
            涉及个人信息：Android ID、IMEI、MEID、OAID
          </div>
          <div class="line">
            使用目的：广告数据监测和投放
          </div>
          <div class="line">
            公司主体名称：易玩（上海）网络科技有限公司
          </div>
          <div class="line">
            收集方式：SDK采集
          </div>
          <div class="line">
            官网链接：<a href="https://developer.taptap.cn/">https://developer.taptap.cn/</a>
          </div>
          <div class="line">
            隐私政策：<a href="https://developer.taptap.cn/docs/sdk/start/agreement/">https://developer.taptap.cn/docs/sdk/start/agreement/</a>
          </div>

        </div>


        <div class="section">
          <div class="boldT line">4.游戏联运渠道SDK</div>
          <div class="line">
            如果您是通过游戏联运渠道(如第三方平台、第三方应用商店等)获取、接入我们的产品与/或服务的，通常情况下，我们的产品与/或服务中的部分功能将通过联运渠道接入的渠道SDK实现，包括登录、实名认证、支付、客服等。在上述特定场景下，您需要授权渠道SDK收集、存储、使用或以其他方式处理您的个人信息，关于渠道SDK处理您的个人信息种类、目的、方式和您享有的权利等事宜，请见渠道SDK隐私政策或相关规则说明。如:您获取软件的渠道为小米应用商店，则(通常)我们的产品与/或服务会接入小米渠道SDK。查看
            <a href="https://kl3g96a53c.feishu.cn/docx/NZkFdAN8OoWSbnxciEXc2fennZf">四川繁羽开天科技有限公司游戏渠道SDK清单</a>
            进一步了解。
          </div>
        </div>


        <div class="section">
          <div class="line">
            《四川繁羽开天科技有限公司游戏渠道SDK清单》
          </div>
          <div class="line">
            （1）SDK名称：bilibiliSDK
          </div>
          <div class="line">
            第三方公司名称：上海宽娱数码科技有限公司
          </div>
          <div class="line">
            涉及的个人信息名称：个人常用设备信息（包括硬件序列号、硬件型号、设备MAC地址、操作系统类型、软件列表、唯一设备识别码）、游戏账号信息、实名信息（姓名、身份证号）、订单及支付信息
          </div>
          <div class="line">
            使用目的：提供账号登录、支付、客户服务以及实名制服务
          </div>
          <div class="line">
            使用场景：用户通过bilibi渠道进行账号登录、实名、支付及咨询客服时
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a href="https://www.bilibili.com/blackboard/privacy-pc.html">https://www.bilibili.com/blackboard/privacy-pc.html</a>
          </div>
          <div class="line">
            （2）SDK名称：华为SDK
          </div>
          <div class="line">
            第三方公司名称：华为技术有限公司
          </div>
          <div class="line">
            涉及的个人信息名称：个人常用设备信息（包括硬件序列号、硬件型号、设备MAC地址、操作系统类型、软件列表、唯一设备识别码）、应用包名、游戏启动时间、游戏账号信息、实名信息（姓名、身份证号）、订单及支付信息
          </div>
          <div class="line">
            使用目的：提供账号登录、支付、客户服务、实名制服务以及数据运营分析
          </div>
          <div class="line">
            使用场景：用户通过华为渠道进行账号登录、实名、支付及咨询客服时
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a href="https://www.huaweicloud.com/declaration/sa_prp.html#">https://www.huaweicloud.com/declaration/sa_prp.html#</a>
          </div>
          <div class="line">
            （3） SDK名称：小米SDK
          </div>
          <div class="line">
            第三方公司名称：小米公司及其关联公司
          </div>
          <div class="line">
            涉及的个人信息名称：个人常用设备信息（包括硬件序列号、硬件型号、设备MAC地址、操作系统类型、软件列表、唯一设备识别码）、游戏账号信息、实名信息（姓名、身份证号）、订单及支付信息
          </div>
          <div class="line">
            使用目的：提供账号登录、支付、客户服务以及实名制服务
          </div>
          <div class="line">
            使用场景：用户通过小米渠道进行账号登录、实名、支付及咨询客服时
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a href="https://privacy.mi.com/xiaomigame-sdk/zh_CN/">https://privacy.mi.com/xiaomigame-sdk/zh_CN/</a>
          </div>
          <div class="line">
            （4） SDK名称：OPPO SDK
          </div>
          <div class="line">
            第三方公司名称：广东欢太科技有限公司
          </div>
          <div class="line">
            涉及的个人信息名称：唯一设备识别码、游戏账号信息、实名信息（姓名、身份证号）、订单及支付信息
          </div>
          <div class="line">
            使用目的：提供账号登录、支付、客户服务以及实名制服务
          </div>
          <div class="line">
            使用场景：用户通过OPPO渠道进行账号登录、实名、支付及咨询客服时
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：
          </div>
          <div class="line">
            <a href="https://cdofs.heytapimage.com/cdo-activity/static/gamecenter/heytap/doc/privacy.html?2020&c=0&ls=1">https://cdofs.heytapimage.com/cdo-activity/static/gamecenter/heytap/doc/privacy.html?2020&c=0&ls=1</a>
          </div>
          <div class="line">
            （5） SDK名称：VIVO SDK
          </div>
          <div class="line">
            第三方公司名称：广东天宸网络科技有限公司
          </div>
          <div class="line">
            涉及的个人信息名称：唯一设备识别码、游戏账号信息、实名信息（姓名、身份证号）、订单及支付信息
          </div>
          <div class="line">
            使用目的：提供账号登录、支付、客户服务以及实名制服务
          </div>
          <div class="line">
            使用场景：用户通过VIVO渠道进行账号登录、实名、支付及咨询客服时
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a href="https://www.vivo.com.cn/about-vivo/privacy-policy">https://www.vivo.com.cn/about-vivo/privacy-policy</a>
          </div>
          <div class="line">
            （6） SDK名称：魅族SDK
          </div>
          <div class="line">
            第三方公司名称：珠海市魅族通讯设备有限公司
          </div>
          <div class="line">
            涉及的个人信息名称：唯一设备识别码、游戏账号信息、实名信息（姓名、身份证号）、订单及支付信息
          </div>
          <div class="line">
            使用目的：提供账号登录、支付、客户服务以及实名制服务
          </div>
          <div class="line">
            使用场景：用户通过魅族渠道进行账号登录、实名、支付及咨询客服时
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私政策链接：<a href="https://www.meizu.com/legal.html">https://www.meizu.com/legal.html</a>
          </div>
          <div class="line">
            （7）联想 SDK
          </div>
          <div class="line">
            第三方公司名称：北京联想调频科技有限公司
          </div>
          <div class="line">
            涉及的个人信息名称：个人常用设备信息（包括IMEI、OAID、Android
          </div>
          <div class="line">
            ID、设备MAC地址）、设备型号、制造商、操作系统、屏幕分辨率、应用版本信息、网络类型、运营商信息、游戏账号信息、实名信息（姓名、身份证号）、订单及支付信息
          </div>
          <div class="line">
            使用目的：提供账号登录、支付、客户服务以及实名制服务
          </div>
          <div class="line">
            使用场景：用户通过联想渠道进行账号登录、实名、支付及咨询客服时
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接： <a href="https://hd.lenovomm.com/activity01/privacy/index.html">https://hd.lenovomm.com/activity01/privacy/index.html</a>
          </div>
          <div class="line">
            （8）SDK名称：金立SDK
          </div>
          <div class="line">
            第三方公司名称：深圳市致璞科技有限公司
          </div>
          <div class="line">
            涉及的个人信息名称：个人常用设备信息（包括硬件序列号、硬件型号、设备MAC地址、操作系统类型、软件列表、唯一设备识别码、游戏账号信息、实名信息（姓名、身份证号）、订单及支付信息
          </div>
          <div class="line">
            使用目的：提供账号登录、支付、客户服务以及实名制服务
          </div>
          <div class="line">
            使用场景：用户通过金立渠道进行账号登录、实名、支付及咨询客服时
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a href="http://devquickapp.gionee.com/help/page/id/4.html">http://devquickapp.gionee.com/help/page/id/4.html</a>
          </div>
          <div class="line">
            （9）SDK名称：酷派SDK
          </div>
          <div class="line">
            第三方公司名称：酷派集团有限公司
          </div>
          <div class="line">
            涉及的个人信息名称：个人常用设备信息（包括硬件序列号、硬件型号、设备MAC地址、操作系统类型、软件列表、唯一设备识别码）、游戏账号信息、实名信息（姓名、身份证号）、订单及支付信息
          </div>
          <div class="line">
            使用目的：提供账号登录、支付、客户服务以及实名制服务
          </div>
          <div class="line">
            使用场景：用户通过酷派渠道进行账号登录、实名、支付及咨询客服时
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接： <a href="https://dev.coolpad.com/#/doc?id=07">https://dev.coolpad.com/#/doc?id=07</a>
          </div>
          <div class="line">
            （10）SDK名称：努比亚SDK
          </div>
          <div class="line">
            第三方公司名称：深圳市努比亚信息技术有限公司
          </div>
          <div class="line">
            涉及的个人信息名称：个人常用设备信息（包括硬件序列号、硬件型号、设备MAC地址、操作系统类型、软件列表、唯一设备识别码）、游戏账号信息、实名信息（姓名、身份证号）、订单及支付信息
          </div>
          <div class="line">
            使用目的：提供账号登录、支付、客户服务以及实名制服务
          </div>
          <div class="line">
            使用场景：用户通过努比亚渠道进行账号登录、实名、支付及咨询客服时
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a href="https://www.nubia.com/active/privacy.html">https://www.nubia.com/active/privacy.html</a>
          </div>
          <div class="line">
            （11） SDK名称：百度SDK
          </div>
          <div class="line">
            第三方公司名称：北京百度网讯科技有限公司
          </div>
          <div class="line">
            涉及的个人信息名称：个人常用设备信息（包括硬件序列号、硬件型号、设备MAC地址、操作系统类型、软件列表、唯一设备识别码）、游戏账号信息、实名信息（姓名、身份证号）、订单及支付信息
          </div>
          <div class="line">
            使用目的：提供账号登录、支付、客户服务以及实名制服务
          </div>
          <div class="line">
            使用场景：用户通过百度渠道进行账号登录、实名、支付及咨询客服时
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a href="https://ai.baidu.com/ai-doc/REFERENCE/Ckdym0tc9">https://ai.baidu.com/ai-doc/REFERENCE/Ckdym0tc9</a>
          </div>
          <div class="line">
            （12）SDK名称：搜狗SDK
          </div>
          <div class="line">
            第三方公司名称：北京搜狗信息服务有限公司
          </div>
          <div class="line">
            涉及的个人信息名称：个人常用设备信息（包括硬件序列号、硬件型号、设备MAC地址、操作系统类型、软件列表、唯一设备识别码）、游戏账号信息、实名信息（姓名、身份证号）、订单及支付信息
          </div>
          <div class="line">
            使用目的：提供账号登录、支付、客户服务以及实名制服务
          </div>
          <div class="line">
            使用场景：用户通过搜狗渠道进行账号登录、实名、支付及咨询客服时
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a href="http://corp.sogou.com/private.html">http://corp.sogou.com/private.html</a>
          </div>
          <div class="line">
            （13） SDK名称：快手SDK
          </div>
          <div class="line">
            第三方公司名称：北京快手科技有限公司
          </div>
          <div class="line">
            涉及的个人信息名称：个人常用设备信息（包括硬件序列号、硬件型号、设备MAC地址、操作系统类型、软件列表、唯一设备识别码）、游戏账号信息、实名信息（姓名、身份证号）、订单及支付信息
          </div>
          <div class="line">
            使用目的：提供账号登录、支付、客户服务以及实名制服务
          </div>
          <div class="line">
            使用场景：用户通过快手渠道进行账号登录、实名、支付及咨询客服时
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a href="https://www.kuaishou.com/about/policy?tab=privacy">https://www.kuaishou.com/about/policy?tab=privacy</a>
          </div>
          <div class="line">
            （14） SDK名称：应用宝SDK
          </div>
          <div class="line">
            第三方公司名称：腾讯科技（深圳）有限公司
          </div>
          <div class="line">
            涉及的个人信息名称：个人常用设备信息（包括硬件序列号、硬件型号、设备MAC地址、操作系统类型、软件列表、唯一设备识别码）、游戏账号信息、实名信息（姓名、身份证号）、订单及支付信息
          </div>
          <div class="line">
            使用目的：提供账号登录、支付、客户服务以及实名制服务
          </div>
          <div class="line">
            使用场景：用户通过应用宝渠道进行账号登录、实名、支付及咨询客服时
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a href="https://privacy.qq.com/document/preview/41461bd464274ce0b5e34181785f5c13">https://privacy.qq.com/document/preview/41461bd464274ce0b5e34181785f5c13</a>
          </div>
          <div class="line">
            （15）SDK名称：360 SDK
          </div>
          <div class="line">
            第三方公司名称：北京奇虎科技有限公司
          </div>
          <div class="line">
            涉及的个人信息名称：个人常用设备信息（包括IMEI、OAID）、游戏账号信息、实名信息（姓名、身份证号）、订单及支付信息
          </div>
          <div class="line">
            使用目的：提供账号登录、支付、客户服务以及实名制服务
          </div>
          <div class="line">
            使用场景：用户通过360渠道进行账号登录、实名、支付及咨询客服时
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a href="https://i.360.cn/reg/privacy">https://i.360.cn/reg/privacy</a>
          </div>
          <div class="line">
            （16） SDK名称：4399SDK
          </div>
          <div class="line">
            第三方公司名称：四三九九网络股份有限公司
          </div>
          <div class="line">
            涉及的个人信息名称：个人常用设备信息（包括硬件序列号、硬件型号、设备MAC地址、操作系统类型、软件列表、唯一设备识别码）、游戏账号信息、实名信息（姓名、身份证号）、订单及支付信息
          </div>
          <div class="line">
            使用目的：提供账号登录、支付、客户服务以及实名制服务
          </div>
          <div class="line">
            使用场景：用户通过4399渠道进行账号登录、实名、支付及咨询客服时
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a href="https://web.4399.com/local/200810/22-1230.html">https://web.4399.com/local/200810/22-1230.html</a>
          </div>
          <div class="line">
            （17） SDK名称：黑鲨SDK
          </div>
          <div class="line">
            第三方公司名称：深圳黑鲨科技有限公司
          </div>
          <div class="line">
            涉及的个人信息名称：个人常用设备信息（包括硬件序列号、硬件型号、设备MAC地址、操作系统类型、软件列表、唯一设备识别码）、游戏账号信息、实名信息（姓名、身份证号）、订单及支付信息
          </div>
          <div class="line">
            使用目的：提供账号登录、支付、客户服务以及实名制服务
          </div>
          <div class="line">
            使用场景：用户通过黑鲨渠道进行账号登录、实名、支付及咨询客服时
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a href="http://cloud.blackshark.com/static/protocol/privacy.html">http://cloud.blackshark.com/static/protocol/privacy.html</a>
          </div>
          <div class="line">
            （18）SDK名称：九游SDK
          </div>
          <div class="line">
            第三方公司名称：广州爱九游信息技术有限公司
          </div>
          <div class="line">
            涉及的个人信息名称：个人常用设备信息（包括硬件序列号、硬件型号、设备MAC地址、操作系统类型、软件列表、唯一设备识别码）、游戏账号信息、实名信息（姓名、身份证号）、订单及支付信息
          </div>
          <div class="line">
            使用目的：提供账号登录、支付、客户服务以及实名制服务
          </div>
          <div class="line">
            使用场景：用户通过九游渠道进行账号登录、实名、支付及咨询客服时
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a href="https://www.9game.cn/tpl/pc/app/private.html">https://www.9game.cn/tpl/pc/app/private.html</a>
          </div>
          <div class="line">
            （19） SDK名称：雷电SDK
          </div>
          <div class="line">
            第三方公司名称：上海畅指网络科技有限公司
          </div>
          <div class="line">
            涉及的个人信息名称：个人常用设备信息（包括硬件序列号、硬件型号、设备MAC地址、操作系统类型、软件列表、唯一设备识别码）、游戏账号信息、实名信息（姓名、身份证号）、订单及支付信息
          </div>
          <div class="line">
            使用目的：提供账号登录、支付、客户服务以及实名制服务
          </div>
          <div class="line">
            使用场景：用户通过雷电渠道进行账号登录、实名、支付及咨询客服时
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a
              href="https://www.ldmnq.com/ldy/ysXieyi.html">https://www.ldmnq.com/ldy/ysXieyi.html</a>
          </div>
          <div class="line">
            （20）SDK名称：益玩SDK
          </div>
          <div class="line">
            第三方公司名称：上海益玩网络科技有限公司
          </div>
          <div class="line">
            涉及的个人信息名称：个人常用设备信息（包括硬件序列号、硬件型号、设备MAC地址、操作系统类型、软件列表、唯一设备识别码）、游戏账号信息、实名信息（姓名、身份证号）、订单及支付信息
          </div>
          <div class="line">
            使用目的：提供账号登录、支付、客户服务以及实名制服务
          </div>
          <div class="line">
            使用场景：用户通过益玩渠道进行账号登录）、实名、支付及咨询客服时
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a href="http://www.ewan.cn/privacyPolicy.html">http://www.ewan.cn/privacyPolicy.html</a>
          </div>
          <div class="line">
            （21） 小七SDK
          </div>
          <div class="line">
            SDK名称：小七SDK
          </div>
          <div class="line">
            第三方公司名称：深圳尚米网络技术有限公司
          </div>
          <div class="line">
            涉及的个人信息名称：个人常用设备信息（包括硬件序列号、硬件型号、设备MAC地址、操作系统类型、软件列表、唯一设备识别码）、游戏账号信息、实名信息（姓名、身份证号）、订单及支付信息
          </div>
          <div class="line">
            使用目的：提供账号登录、支付、客户服务以及实名制服务
          </div>
          <div class="line">
            使用场景：用户通过小七渠道进行账号登录、实名、支付及咨询客服时
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a href="http://uct.x7sy.com/tggame/privacy">http://uct.x7sy.com/tggame/privacy</a>
          </div>
          <div class="line">
            （22） SDK名称：玩咖SDK
          </div>
          <div class="line">
            第三方公司名称：欢聚时代文化传媒（北京）有限公司
          </div>
          <div class="line">
            涉及的个人信息名称：个人常用设备信息（包括硬件序列号、硬件型号、设备MAC地址、操作系统类型、软件列表、唯一设备识别码）、游戏账号信息、实名信息（姓名、身份证号）、订单及支付信息
          </div>
          <div class="line">
            使用目的：提供账号登录、支付、客户服务以及实名制服务
          </div>
          <div class="line">
            使用场景：用户通过玩咖渠道进行账号登录、实名、支付及咨询客服时
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a href="http://file.wankacn.com/jingzheshiji/privacy.html">http://file.wankacn.com/jingzheshiji/privacy.html</a>
          </div>
          <div class="line">
            （23）SDK名称：mumu模拟器SDK
          </div>
          <div class="line">
            第三方公司名称：广州网易计算机系统有限公司
          </div>
          <div class="line">
            涉及的个人信息名称：个人常用设备信息（包括硬件序列号、硬件型号、设备MAC地址、操作系统类型、软件列表、唯一设备识别码）、游戏账号信息、实名信息（姓名、身份证号）、订单及支付信息
          </div>
          <div class="line">
            使用目的：提供账号登录、支付、客户服务以及实名制服务
          </div>
          <div class="line">
            使用场景：用户通过mumu模拟器渠道进行账号登录、实名、支付及咨询客服时共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a href="https://mumu.163.com/20211102/25905_983292.html">https://mumu.163.com/20211102/25905_983292.html</a>
          </div>
          <div class="line">
            （24） SDK名称：安久（游戏fan）SDK
          </div>
          <div class="line">
            第三方公司名称：广东安久科技有限公司
          </div>
          <div class="line">
            涉及的个人信息名称：个人常用设备信息（包括硬件序列号、硬件型号、设备MAC地址、操作系统类型、软件列表、唯一设备识别码）、游戏账号信息、实名信息（姓名、身份证号）、订单及支付信息
          </div>
          <div class="line">
            使用目的：提供账号登录、支付、客户服务以及实名制服务
          </div>
          <div class="line">
            使用场景：用户通过安久渠道进行账号登录、实名、支付及咨询客服时
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a href="http://www.youxifan.com/aboutUs/3">http://www.youxifan.com/aboutUs/3</a>
          </div>
          <div class="line">
            （25） SDK名称：TT语音SDK
          </div>
          <div class="line">
            第三方公司名称：广州趣丸网络科技有限公司
          </div>
          <div class="line">
            涉及的个人信息名称：个人常用设备信息（包括硬件序列号、硬件型号、设备MAC地址、操作系统类型、软件列表、唯一设备识别码）、游戏账号信息、实名信息（姓名、身份证号）、订单及支付信息
          </div>
          <div class="line">
            使用目的：提供账号登录、支付、客户服务以及实名制服务
          </div>
          <div class="line">
            使用场景：用户通过TT语音渠道进行账号登录、实名、支付及咨询客服时
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a href="https://privacypolicysdk.skyengine.com.cn/privacypolicy/index.html">https://privacypolicysdk.skyengine.com.cn/privacypolicy/index.html</a>
          </div>
          <div class="line">
            （26） SDK名称：当乐SDK
          </div>
          <div class="line">
            第三方公司名称：北京当乐信息技术有限公司
          </div>
          <div class="line">
            涉及的个人信息名称：个人常用设备信息（包括硬件序列号、硬件型号、设备MAC地址、操作系统类型、软件列表、唯一设备识别码）、游戏账号信息、实名信息（姓名、身份证号）、订单及支付信息
          </div>
          <div class="line">
            使用目的：提供账号登录、支付、客户服务以及实名制服务
          </div>
          <div class="line">
            使用场景：用户通过当乐渠道进行账号登录、实名、支付及咨询客服时
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a href="https://ngsdk.d.cn/faq/user_privacy.html">https://ngsdk.d.cn/faq/user_privacy.html</a>
          </div>
          <div class="line">
            （27） SDK名称：果盘SDK
          </div>
          <div class="line">
            第三方公司名称：火烈鸟网络（广州）股份有限公司
          </div>
          <div class="line">
            涉及的个人信息名称：个人常用设备信息（包括硬件序列号、硬件型号、设备MAC地址、操作系统类型、软件列表、唯一设备识别码）、游戏账号信息、实名信息（姓名、身份证号）、订单及支付信息
          </div>
          <div class="line">
            使用目的：提供账号登录、支付、客户服务以及实名制服务
          </div>
          <div class="line">
            使用场景：用户通过果盘渠道进行账号登录、实名、支付及咨询客服时
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a href="http://user.guopan.cn/conceal.html">http://user.guopan.cn/conceal.html</a>
          </div>
          <div class="line">

          </div>
          <div class="line">
            （28） SDK名称：TAP SDK
          </div>
          <div class="line">
            第三方公司名称：火烈鸟网络（广州）股份有限公司
          </div>
          <div class="line">
            涉及的个人信息名称：个人常用设备信息（包括IMEI、OAID、Android ID、设备MAC地址）、设备型号、制造商、操作系统、屏幕分辨率、应用版本信息、网络类型、运营商信息、游戏账号信息、实名信息（姓名、身份证号）、订单及支付信息
          </div>
          <div class="line">
            使用目的：用于优化应用性能、提供个性化服务、进行数据分析以改进产品和服务。
          </div>
          <div class="line">
            使用场景：在应用的后台进行数据处理和分析，以了解用户行为模式、优化用户体验、推送相关内容。
          </div>
          <div class="line">
            共享方式：SDK本机采集
          </div>
          <div class="line">
            第三方隐私链接：<a href="https://www.taptap.cn/doc/privacy-policy/">https://www.taptap.cn/doc/privacy-policy/</a>
          </div>

          <div class="line">
            （29）sdk名称：小米游戏联运SDK
          </div>
          <div class="line">
            第三方公司名称：北京瓦力网络科技有限公司
          </div>
          <div class="line">
            涉及的个人信息名称：个人常用设备信息（包括 OAID、Android ID、IMEI（Android Q 以下版本）、IMSI、设备 MAC 地址、设备序列号、硬件序列号、SIM 卡序列号、ICCID、MEID（部分 CDMA 手机））、设备型号、设备制造商、操作系统（androidapi 版本号、操作系统版本）、屏幕相关信息（屏幕适配所需信息）、应用版本信息（应用包名、版本号）、网络类型、运营商信息、网络可用状态、IP 地址、Wi-Fi 状态及参数（SSID、BSSID）、传感器信息、游戏账号信息（小米 ID、游戏账号）、实名信息（姓名、身份证号、证件照片、手机号）、订单及支付信息（订单号、支付金额、支付方式、小米 ID（关联支付）、网络状态信息（关联支付））、用户生物轨迹信息（操作验证过程中滑动、点击轨迹等）、设备环境信息（系统设置、系统属性、软件安装列表、应用运行状态）
          </div>
          <div class="line">
            使用目的：用于校验开发者账号信息一致性，保障稳定安全的登录与支付服务；依据法律法规要求完成游戏用户实名制认证及防沉迷管理（上报用户游戏上下线时间等）；判断网络连接状态以保证服务连续性；提供摇一摇打开宝箱的扩展功能；统计用户维度游戏激活、崩溃等 UV+PV 数据以优化产品；检测异常机器流量，拦截灰黑产异常流量，保障业务安全；实现支付功能及支付安全防护，提升用户体验。
          </div>
          <div class="line">
            使用场景：在用户登录游戏（验证账号一致性）、发起支付订单（保障支付安全、传递订单信息）、使用摇一摇打开宝箱功能（调用传感器）时；在游戏前后台切换（防沉迷检测用户活跃状态）、应用运行中网络状态变化（判断网络连接）时；在后台进行数据统计分析（游戏激活、崩溃数据收集）、异常流量识别（业务安全防护）、用户实名验证（对接实名认证系统）过程中，进行数据采集、处理与共享（符合法规及隐私政策约定）。
          </div>
          <div class="line">
            共享方式：SDK 本机采集基础信息；部分信息通过 API（如网络游戏防沉迷实名认证系统 API、捷付睿通实名认证接口）或第三方 SDK（如支付宝支付 SDK、小米支付 SDK、小米帐号 SDK、极意行为验证 SDK）与合作方共享（共享前已通过隐私政策明确告知，且采取加密等安全措施，符合合法、正当、必要原则）。
          </div>
          <div class="line">
            第三方隐私链接：<a href="https://dev.mi.com/xiaomihyperos/documentation/detail?pId=1402">https://dev.mi.com/xiaomihyperos/documentation/detail?pId=1402</a>
          </div>

        </div>

        <div class="section">
          <div class="boldT line">(二)转让</div>
          <div class="line">
            转让是指将个人信息控制权向其他公司、组织或个人转移的过程。原则上我们不会将您的个人信息转让，但以下情况除外:
          </div>
          <div class="line">1.您自行提出要求，且符合法律法规及监管的相关规定条件的。</div>
          <div class="line">2.根据法律法规或强制性的行政或司法要求；</div>
          <div class="line">
            3.如果我们因合并、分立、解散、被宣告破产的原因需要转移个人信息的，我们会向您告知接收方的名称或者姓名和联系方式，并要求接收方继续受本政策的约束。接收方变更原先的处理目的、处理方式的，我们将要求接收方重新取得您的同意。
          </div>
          <div class="line">（三）公开披露</div>
          <div class="line">
            <span>原则上我们不会将用户的信息进行公开披露。确需展示时，我们会予以</span>
            <span class="boldT">脱敏</span>
            <span>。如确需要完全公开披露，我们将会向用户告知公开披露的目的、披露信息的类型及可能涉及的相关信息，并征得用户的</span>
            <span class="boldT">单独同意。</span>
          </div>
        </div>
        <div class="section">
          <div class="boldT line">四、您对个人信息享有的控制权</div>
          <div class="line">
            <span>我们非常重视您作为个人信息主体所享有的权利，并尽全力保护您对您的个人信息的控制权，为您提供多种方式方便您更安心、更便捷地进行隐私设置及个人信息管理，保障您的个人信息安全。请您理解，部分服务/功能需要处理您的个人信息方可实现，因此，如果您撤回我们对您信息处理的同意/授权，则可能会影响您使用相应服务/功能，但不影响您其他服务/功能的使用。同时，</span>
            <span class="boldT">您撤回同意/授权的，不影响撤回前基于您的同意/授权已进行的个人信息处理的活动。</span>
          </div>
          <div class="boldT line">(一)查询、更正/修改、删除您的个人信息</div>
          <div class="line">
            您可以在您使用的我们的游戏产品中查询与访问您的账号基础信息(如头像、昵称，以及其他您选择填写的个人信息)、游戏历史信息(如等级、战力、背包物品、对局记录，以及各产品特定的游戏信息)，并可对上述部分信息进行更正/修改、删除。
          </div>
          <div class="line">
            对于您在行使上述权利过程中遇到的困难，如无法在线上自行更正/修改部分信息或当您发现我们处理的您的个人信息有错误时，您有权通过我们公布的反馈、报错等途径将您的更正/修改申请提交给我们，要求我们做出更正/修改。但出于安全性和身份识别的考虑，您可能无法修改注册时提交的某些初始注册信息。在以下情形中，您可以直接向我们提出删除您的个人信息的请求，但已做数据匿名化处理或法律法规另有规定的除外:
          </div>
          <div class="line">1.处理目的已实现、无法实现或者为实现处理目的不再必要</div>
          <div class="line">2.我们停止提供产品与/或服务，或者保存期限已届满;</div>
          <div class="line">3.您撤回同意;</div>
          <div class="line">
            4.我们违反法律、行政法规或者违反约定处理您的个人信息。您理解并同意:当您从我们的产品与/或服务中删除信息后，我们可能不会立即从备份系统中删除相应的信息，但会在备份更新时删除这些信息或者将安全地存储用户的个人信息并将其与其他信息进一步处理隔离，直到备份可以清除或实现匿名。
          </div>
          <div class="line">
            若我们决定响应用户的删除请求，我们还将同时通知从我们获得用户的个人信息的合作方，要求其及时删除，除非法律法规另有规定，或这些合作方获得用户的独立授权。
          </div>
          <div class="boldT line">(二)撤回同意</div>
          <div class="line">您可以通过以下方式改变或者撤回您授权我们处理您的个人信息的范围:</div>
          <div class="line">
            1.系统权限设置:您可以通过设备系统设置管理我们产品使用的系统权限授权，例如:i0S设备中的“设置-隐私-照片“来撤回您对照片权限的授权。
          </div>
          <div class="line">
            2.商业信息接收设置:您有权拒绝我们的商业性营销信息。例如:在疯狂原始人App"我的一账户安全一商业信息接收”中选择拒绝接收。
          </div>
          <div class="line">3.除本政策中已有说明外，其他设置具体以产品实际提供为准，</div>
          <div class="boldT line">（三)注销账号</div>
          <div class="line">您可以通过以下方式注销您的账号</div>
          <div class="line">1.线上注销。例如:在疯狂原始人App中通过路径:"游戏个人中心-账户安全-账户注销”申请注销账号。
          </div>
          <div class="line">2.联系我们的客服进行账号注销。</div>
          <div class="line">3.其他我们公示的途径。</div>
          <div class="boldT line">
            在您注销账号后，该账号下的内容、信息、数据、记录等将会被删除或匿名化处理(但法律法规另有规定或监管部门另有要求的除外);同时，账号一旦注销完成，将无法恢复。
          </div>
          <div class="line">更多关于四川繁羽开天科技有限公司账号注销的流程、注意事项等详见
            <a href="https://kl3g96a53c.feishu.cn/docx/HCpVd2BJIo7p2SxdyAScOYWTnfg">《四川繁羽开天科技有限公司账号注销协议》</a>
          </div>


        </div>
        <div class="section">
          <div class="line">
            《四川繁羽开天科技有限公司账号注销协议》
          </div>
          <div class="line">
            【特别说明】亲爱的用户，在您正式开始注销四川繁羽开天科技有限公司账号前，我们先为您做出如下特别说明：账号注销后，您将无法再以此账号登录和使用四川繁羽开天科技有限公司传媒有限公司及/或其关联公司（以下简称“我们”或者“四川繁羽开天科技有限公司”）的相关产品与服务。四川繁羽开天科技有限公司传媒有限公司也将同时终止为该账号提供我们的高品质、多元化的产品与服务，这同时也不可避免地会给您的售后维权带来不便。且四川繁羽开天科技有限公司账号一旦注销完成，将无法恢复。请您在注销前慎重考虑。
          </div>
          <div class="line">
            若您经过慎重考虑后仍执意决定注销四川繁羽开天科技有限公司账号，请您务必先行仔细阅读和充分理解本《四川繁羽开天科技有限公司账号注销协议》，在同意全部内容后，按照我们的注销操作指引进行下一步操作，您勾选本注销协议并点击下一步注销操作的行为即视为您已经同意签署和遵守本协议全部内容。
          </div>
          <div class="line">
            （如您执意决定注销四川繁羽开天科技有限公司账号的，请继续向下阅读）
          </div>
          <div class="line">

          </div>
          <div class="line">
            一、您需要首先知悉的是：账号注销将会对您产生如下影响：
          </div>
          <div class="line">
            1、一旦注销，您将无法登录、使用该账号（包括无法使用通过第三方账号（如：微博、微信等账号）授权登录的方式，该账号绑定的第三方账号将自动解绑），即您将无法再以此账号登录/使用/继续使用四川繁羽开天科技有限公司传媒有限公司旗下的相关产品与服务；
          </div>
          <div class="line">
            2、一旦注销，您曾通过该账号登录、使用的四川繁羽开天科技有限公司传媒有限公司旗下的产品与服务下的所有内容、信息、数据、记录将会被删除或匿名化处理，您也无法再检索、访问、获取、继续使用和找回，也无权要求我们找回，同时，您亦不再享有《四川繁羽开天科技有限公司隐私政策》中约定的您的用户权利，但法律法规另有规定或监管部门另有要求的除外。上述内容、信息、数据、记录包括：
          </div>
          <div class="line">
            （1）该账号下的个人资料（例如：头像、昵称等）及绑定信息（例如：绑定手机号、邮箱等）；
          </div>
          <div class="line">
            （2）该账号下的您的数据与使用记录（例如：浏览记录、观影历程、搜索记录、收藏、关注及粉丝列表等）；
          </div>
          <div class="line">
            （3）该账号曾发表的所有内容（例如：音视频、图片、照片、评论、互动、点赞等）；
          </div>
          <div class="line">
            （4）其他所有内容、信息、数据、记录。
          </div>
          <div class="line">
            （5）请您知悉并理解，部分非存储在您账号下的信息，如您在我们的产品内发送给其他用户的消息或信息，在您注销后其他用户可能仍能看到，但前述信息将会被匿名化展示。
          </div>
          <div class="line">
            3、您申请账号注销的行为即表明您同意放弃该账号在四川繁羽开天科技有限公司传媒有限公司旗下的产品与服务使用期间已产生的但未消耗完毕的权益及未来的预期利益。即四川繁羽开天科技有限公司账号一旦注销，我们将会对该账号下的全部权益做清除处理，您将无法继续使用，且无法要求我们恢复。包括：
          </div>
          <div class="line">
            （1）您尚未到期的各类VIP会员权益、等级等；
          </div>
          <div class="line">
            （2）您尚未使用的积分、卡券、优惠券、代金券、成长值等；
          </div>
          <div class="line">
            （3）您游戏角色下的虚拟货币、充值道具等；
          </div>
          <div class="line">
            （4）您在四川繁羽开天科技有限公司传媒有限公司旗下的产品与/或服务中发布的内容未来的收益权益；
          </div>
          <div class="line">
            （5）您在四川繁羽开天科技有限公司传媒有限公司旗下的产品与/或服务中的各类身份权益；
          </div>
          <div class="line">
            （6）您在四川繁羽开天科技有限公司传媒有限公司旗下的产品与/或服务中已经购买的未到期的在线服务内容；
          </div>
          <div class="line">
            （7）其他已产生但未消耗完毕的权益或未来预期的收益。
          </div>
          <div class="line">
            4、一旦注销，将无法恢复（即使您在注销后以同一手机号码再次向我们申请注册四川繁羽开天科技有限公司账号），此时该账号为新的用户账号，不承继任何已注销账号下的内容、信息、数据、记录或任何权益与收益。因此，我们善意地提醒您在申请注销前对您认为需要备份的内容提前自行做好备份；
          </div>
          <div class="line">
            5、一旦注销，您与我们曾签署过的相关用户协议、其他权利义务性文件等相应终止（但我们与您之间已约定继续生效的或法律法规另有规定的除外）；
          </div>
          <div class="line">
            6、一旦注销，您与我们之间不再存在就任何您使用的我们的产品与/或服务相关的权利义务关系，您无权就使用四川繁羽开天科技有限公司产品与/或服务向我们提起任何诉讼、仲裁或其他争议处理程序；
          </div>
          <div class="line">
            7、其他因四川繁羽开天科技有限公司账号注销产生的结果
          </div>
          <div class="line">

          </div>
          <div class="line">
            二、在您向我们申请注销四川繁羽开天科技有限公司账号之前或正在申请注销四川繁羽开天科技有限公司账号的过程中，为保障您的账号安全和财产权益，请您先行检查与确保您申请注销的四川繁羽开天科技有限公司账号已经同时满足以下几点条件，包括
          </div>
          <div class="line">
            1、该账号是通过我们的官方渠道注册、符合《四川繁羽开天科技有限公司服务协议》及相关平台说明规范的账号；且该账号为您本人注册的账号；
          </div>
          <div class="line">
            2、该账号处于安全状态，即您在提交注销的最近3个月内无异常登录记录，且账号无修改密码、无换绑手机号码等敏感操作；
          </div>
          <div class="line">
            3、该账号内无资金，包括但不限于：
          </div>
          <div class="line">
            （1）零钱/零钱Plus内资金已被提现或消费完毕；
          </div>
          <div class="line">
            （2）奇点/奇豆已被消费完毕；
          </div>
          <div class="line">
            （3）金融业务中的相关金额已被提现或消费完毕；
          </div>
          <div class="line">
            （4）账号内的其他资金均已被提现或消费完毕。
          </div>
          <div class="line">
            4、该账号内无未处理完毕的交易，包括：
          </div>
          <div class="line">
            （1）商城交易中无未完成的订单；
          </div>
          <div class="line">
            （2）零钱/零钱Plus/奇点/奇豆无正在处理中的订单；
          </div>
          <div class="line">
            （3）金融业务中无未还款完毕的订单；无欠款；
          </div>
          <div class="line">
            （4）流量充值中无充值进行中的订单；
          </div>
          <div class="line">
            （5）无其他未处理完毕的交易或已提供服务但未支付的订单/服务。
          </div>
          <div class="line">
            5、如该账号曾开通了“自动续费”功能的，请您取消“自动续费”。
          </div>
          <div class="line">
            6、其他为了保障您的账号安全和财产权益需要满足的内容。
          </div>
          <div class="line">

          </div>
          <div class="line">
            三、注销四川繁羽开天科技有限公司账号的流程
          </div>
          <div class="line">
            1、注销方式：
          </div>
          <div class="line">
            （1）线上注销：您可以通过产品内的账号线上注销功能进行账号注销。例如：手机端四川繁羽开天科技有限公司App的注销功能路径为：我的-设置-账号与安全-安全中心-账号注销，您可以按照页面操作指引进行线上注销；
          </div>
          <div class="line">
            （2）联系客服注销：通过客服邮箱
            <a href="luyou@fanyukaitian.com.cn">luyou@fanyukaitian.com.cn</a>
            联系客服协助您进行账号注销。
          </div>
          <div class="line">
            2、本《四川繁羽开天科技有限公司账号注销协议》中包含了账号注销对您权益产生的影响等多方面的内容阐述，请您仔细阅读与充分理解，在同意本《四川繁羽开天科技有限公司账号注销协议》的全部内容后再进行下一步注销操作；
          </div>
          <div class="line">
            3、为保障您的账号安全和财产权益，我们需要进行注销申请的身份验证（例如：验证账号绑定的手机号码等），以确保该账号真的是您本人注册的；
          </div>
          <div class="line">
            4、账号注销时间：
          </div>
          <div class="line">
            为保护您的账号安全、财产及身份权益、确保您的账号不会被他人恶意注销，我们将对您申请注销的账号的状态做风险判断。风险判断结果可能影响您账号注销所需的实际时间（具体您账号注销所需的实际时间以您申请时相关页面显示为准），但我们保证，您的账号注销的处理期限最长为15日（从成功提交申请之时起算，即：在您成功提交注销申请后，您的账号最多将需要15日完成注销），但法律法规另有规定或本协议另有约定的除外。
          </div>
          <div class="line">
            前述注销所需时间为账号冻结期，在冻结期内，您无法登录与使用该账号，亦无法使用该账号绑定的手机号码注册新账号；但是，在此期间内，您可以通过产品页面上的恢复功能（例如：如手机端四川繁羽开天科技有限公司App的恢复功能路径为：我的-帮助反馈-账号注销-申请恢复账号）或联系客服来恢复账号的正常使用；
          </div>
          <div class="line">
            如超过上述期限后，我们未收到您恢复账号请求，该账号将被永久注销。
          </div>
          <div class="line">
            5、请您理解并知悉，若您的账号处于诉讼、仲裁、政府调查、被投诉、被举报等涉及纠纷与争议的期间，您申请注销账号的，我们有权在不需获得您许可的情况下自行决定拒绝您的注销申请；若您的账号处在冻结期，发生前述纠纷与争议的，我们有权在不需获得您许可的情况下自行决定终止您的账号注销流程并恢复您的账号。同时，您知悉并同意：即使您的四川繁羽开天科技有限公司账号被注销了，也并不代表减轻或免除您应根据相关法律法规、相关协议、规则等（可能）需要承担的相关责任。
          </div>
          <div class="line">
            6、若我们有合理理由怀疑或发现您的账号存在或可能存在“薅羊毛”、“黑产”等违法违规行为的，我们有权拒绝您的注销申请、终止您的账号注销流程，或不允许通过您的账号绑定的手机号再次注册为新的用户账号。
          </div>
          <div class="line">

          </div>
          <div class="line">
            四、其他
          </div>
          <div class="line">
            1、本协议未尽事宜，请参考《四川繁羽开天科技有限公司服务协议》、《四川繁羽开天科技有限公司隐私政策》及注销过程中的平台相关规则、说明等。
          </div>
          <div class="line">
            2、如在四川繁羽开天科技有限公司账号注销过程中有任何问题您无法处理的或在处理过程中有任何疑惑的，可联系四川繁羽开天科技有限公司客服协助处理。
          </div>
          <div class="line">
            3、本协议之效力、解释、变更、执行与争议解决均适用中华人民共和国法律。因本协议产生之争议，双方尽最大诚意进行友好协商，如果双方不能协商一致，均应依照中华人民共和国法律予以处理，并由成都市高新区人民法院管辖。
          </div>
          <div class="line">

          </div>
          <div class="line">
            四川繁羽开天科技有限公司
          </div>
        </div>

        <div class="section">
          <div class="boldT line">(四)提前获知产品与/或服务停止运营</div>
          <div class="line">
            我们将持续为您提供优质服务，若因特殊原因导致我们的部分或全部产品与/或服务被迫停止运营，我们将提前在显著位置或向您发送推送消息或以其他方式通知您，并将停止对您的个人信息的收集，同时在超出法律法规规定的必需且最短期限后，我们将会对所持有的您的个人信息进行删除或匿名化处理，
          </div>
          <div class="boldT line">(五)帮助与反馈</div>
          <div class="line">我们为您提供了多种反馈渠道，具体请见本政策第八章节“如何联系我们"</div>
        </div>
        <div class="section">
          <div class="boldT line">五、我们如何存储和保护您的个人信息</div>
          <div class="boldT line">(一)个人信息的存储</div>
          <div class="boldT line">1.存储地点</div>
          <div class="line">
            <span class="boldT">我们在中华人民共和国境内运营中收集和产生的个人信息存储于中华人民共和国境内。</span>
            <span>仅在以下情形，目在满足法律法规及监管部门的相关规定后，我们可能会向境外主体提供您的个人信息，并将严格要求接收方按照相关法律法规要求及本政策来处理您的个人信息:</span>
          </div>
          <div class="line">(1)法律法规有明确规定;</div>
          <div class="line">(2)另行获得您单独同意;</div>
          <div class="line">
            (3)您使用的产品与/或服务涉及跨境，您主动向境外提供个人信息。但会向您告知境外接收方的名称或者姓名、联系方式、处理目的、处理方式、个人信息的种类以及用户向境外接收方行使法律规定权利的方式和程序等事项，当相关个人信息达到法定限额，我们会向主管机关申请个人信息出境安全评估。
          </div>
          <div class="boldT line">2.存储期限:</div>
          <div class="line">
            我们在为提供我们的产品与/或服务之目的所必需且最短的期间内保留您的个人信息，例如:当您使用我们的注册登录功能时，我们需要收集您的手机号码，且在您提供后并在您使用该功能期间，我们需要持续为您保留您的手机号码，以向您正常提供该功能、保障您的账号和系统安全在您主动删除个人信息、注销账号或超出必要的存储期限后，我们会对您的个人信息进行删除或匿名化处理，但法律法规另有规定的除外(例如:《电子商务法》规定:商品和服务信息、交易信息保存时间自交易完成之日起不少于三年)。
          </div>
          <div class="line">我们判断个人信息的必要存储期限主要依据以下标准:</div>
          <div class="line">(1)维护相应交易及业务记录，以应对您可能的查询或投诉;</div>
          <div class="line">(2)保证我们为您提供服务的安全和质量;</div>
          <div class="line">(3)您是否同意更长的留存期间；</div>
          <div class="line">(4)是否存在保留期限内的其他特别约定。</div>
          <div class="line">
            在您的个人信息超出存储期间后，我们会根据适用法律的要求删除您的个人信息，或对其进行匿名化处理。如我们停止运营，我们将及时停止继续收集个人信息的活动，对所持有的个人信息进行删除或匿名化处理。
          </div>
          <div class="boldT line">(二)个人信息的保护措施</div>
          <div class="line">
            我们一直都极为重视保护用户的个人信息安全，为此我们采用了符合行业标准的安全技术及组织和管理等保护措施以最大程度降低您的信息被泄露、毁损、误用、非授权访问、非授权披露和更改的风险。包括:
          </div>
          <div class="line">
            1.采用多种安全技术措施对数据的收集、传输、存储、处理、销毁、审计等环节进行管控。
          </div>
          <div class="line">
            2.建立个人信息安全保护组织，落实个人信息安全规范处理、信息安全宣贯与培训等措施。
          </div>
          <div class="line">
            3.构建并完善包括安全体系认证、业务安全能力认证及网络安全等级保护认证的个人信息安全管理体系
          </div>
          <div class="line">4.建立安全应急响应体系、安全事件应急处理机制，及时、高效完成安全事件处理
          </div>
          <div class="line">
            请您知悉并理解，互联网并非绝对安全的环境，我们强烈建议您通过安全方式、使用复杂密码、定期修改密码、不将自己的账号密码及相关个人信息披露给他人等方式，协助我们保证您的账号安全。如您发现自己的个人信息泄密，尤其是您的账户或密码发生泄露，请您立即根据本隐私政策文未中提供的联系方式联络我们，以便我们采取相应措施来保护您的信息安全。
          </div>
        </div>
        <div class="section">
          <div class="boldT line">六、未成年人保护</div>
          <div class="line">
            <span>我们一直非常注重对未成年人的保护，致力于践行我们的企业社会责任。</span>
            <span class="boldT">我们按照国家防沉迷政策要求接入国家防沉迷系统，通过实名认证校验程序确保将未成年人账号纳入防沉迷管理，积极引导未成年人合理游戏，保护未成年人的合法权益。</span>
          </div>
          <div class="line">
            如您为未成年人，应首先取得其监护人的同意(包括本政策)，在监护人同意后和指导下进行使用、提交个人信息。
          </div>
          <div class="line">如果您是14周岁以下儿童的，在您使用我们的服务前，请您通知您的监护人阅读我们的
            <a href="https://kl3g96a53c.feishu.cn/docx/AHJ4dCNFyouETvxl5sDc1mBGnTc">四川繁羽开天科技有限公司儿童信息保护规则</a>
            ，并请您在监护人的授权同意后，在监护人的指导下使用我们的产品与/或服务。对于经监护人同意使用我们的产品与/或服务的情况，我们只会在法律法规允许、监护人明确同意或者保护未成年人所必要的情况下收集、使用、共享、转让或公开披露。更多有关我们对儿童个人信息的处理和保护规则等，请查阅《四川繁羽开天科技有限公司儿童个人信息保护规则》
          </div>
        </div>


        <div class="section">
          <div class="line">

            《四川繁羽开天科技有限公司儿童信息保护规则》
          </div>
          <div class="line">
            导言
          </div>
          <div class="line">
            四川繁羽开天科技有限公司（以下也称“我们”）一直非常注重对儿童个人信息的保护，致力于践行我们的企业社会责任。本《四川繁羽开天科技有限公司儿童个人信息保护规则》（以下也称“本规则”）旨在更详细地向监护人（以下亦称“您”）和您监护的儿童（指未满十四周岁的未成年人，以下亦称“您的孩子”）说明我们如何处理儿童个人信息，以及我们为您/您的孩子提供的管理、保护这些信息的方式。
          </div>
          <div class="line">
          </div>
          <div class="line">
            本规则中涉及与您/您的孩子的权益（可能）存在重大关系的条款以及涉及敏感个人信息的处理，我们已经以字体加粗的方式提示您重点阅读。
          </div>
          <div class="line">
            监护人提醒：
          </div>
          <div class="line">
            在使用我们的产品与/或服务之前，请您仔细阅读、理解本规则，在接受并同意本规则后，再允许您的孩子使用我们的产品与/或服务。
          </div>
          <div class="line">
            儿童提醒：
          </div>
          <div class="line">
            如果您是儿童，请您通知您的监护人阅读本规则，并请您在监护人的授权同意后，在监护人的管理下使用我们的产品与/或服务。
          </div>
          <div class="line">
            儿童个人信息保护特别说明：
          </div>
          <div class="line">
            儿童个人信息保护需要您和我们携手共同努力，我们希望您协助我们保护您的孩子的个人信息。请您注意，儿童的个人信息属于敏感个人信息，请监护人谨慎对待儿童个人信息，并确保您的孩子的相关操作（如授权、信息提供等）在您的同意后进行。

          </div>
          <div class="line">
            关于我们
          </div>
          <div class="line">
            我们主要的运营公司基本情况如下：
          </div>
          <div class="line">
            四川繁羽开天科技有限公司，注册地址/常用办公地址：中国(四川)自由贸易试验区成都高新区梓州大道6900号6楼633号，联系邮箱：
            <a href="luyou@fanyukaitian.com.cn">luyou@fanyukaitian.com.cn</a>
          </div>
          <div class="line">
            如您想更详细地了解我们的公司、平台，您可以通过本规则提供的联系方式与我们联系。

          </div>
          <div class="line">
            本《四川繁羽开天科技有限公司儿童个人信息保护规则》将帮助您了解以下内容：
          </div>
          <div class="line">
            一、 本《四川繁羽开天科技有限公司儿童个人信息保护规则》适用范围
          </div>
          <div class="line">
            二、 我们收集和使用儿童个人信息的规则
          </div>
          <div class="line">
            三、 我们共享、转让、公开披露儿童个人信息的规则
          </div>
          <div class="line">
            四、 对儿童个人信息的控制权
          </div>
          <div class="line">
            五、 我们存储和保护儿童个人信息的规则
          </div>
          <div class="line">
            六、 本规则的更新
          </div>
          <div class="line">
            七、 如何联系我们
          </div>
          <div class="line">
            如您在阅读本《四川繁羽开天科技有限公司儿童个人信息保护规则》或您/您的孩子在使用我们的产品与/或服务的过程中有任何疑惑或其他相关事宜的，请通过文末的方式与我们联系。

          </div>
          <div class="line">
            一. 本《四川繁羽开天科技有限公司儿童个人信息保护规则》适用范围
          </div>
          <div class="line">
            本《四川繁羽开天科技有限公司儿童个人信息保护规则》适用于您/您的孩子在使用我们的产品与/或服务的过程中，我们处理儿童个人信息的活动。
          </div>
          <div class="line">
            二. 我们收集和使用儿童个人信息的规则
          </div>
          <div class="line">
            我们会严格履行法律规定的儿童个人信息保护义务与责任，遵循合法正当、最小必要、目的明确、公开透明、安全保障等原则收集和使用儿童个人信息，不会收集与我们提供的产品与/或服务无关的儿童个人信息，不会违反法律规定和我们与您的约定收集、使用儿童个人信息。
          </div>
          <div class="line">
            我们可能收集您的孩子的个人信息的具体业务功能场景包括：
          </div>
          <div class="line">
            (一) 互动活动等主动提供信息场景
          </div>
          <div class="line">
            您在使用我们的产品与/或服务中主动向我们提供您的孩子的个人信息。
          </div>
          <div class="line">
            (二) 青少年模式
          </div>
          <div class="line">
            青少年模式是为更好地呵护未满 18 周岁未成年人健康成长而提供的音视频观看模式。您可以在我们的产品与/或服务中为您的孩子开启青少年模式。
          </div>
          <div class="line">
            在青少年模式下，您可以建立儿童专属账号对您的孩子的资料进行管理。在您创建儿童专属账号的过程中，我们会收集您可能向我们提供的儿童个人信息（包括昵称、生日、性别、头像），我们收集这些信息用以完成儿童专属账号的创建，并据此提供更适合您的孩子的优质内容。我们在此善意的建议您，如无必要，请不要提供儿童的真实姓名、肖像、联系方式等信息，也不要轻易与他人共享儿童个人信息或将其公开发布。您在上传/更换头像时，我们可能会请求您的相机权限，并收集您上传/更换的图片信息。如您拒绝仅会使您/您的孩子无法使用该功能，但并不影响您/您的孩子正常使用产品与/或服务的其他功能。
          </div>
          <div class="line">
            (三) 其他
          </div>
          <div class="line">
            除非法律、行政法规另有规定，因业务需要，当确需超出本规则约定的目的、范围收集、使用您的孩子的个人信息的，我们会再次征得您的明确同意。
          </div>
          <div class="line">
            三. 我们共享、转让、公开披露儿童个人信息的规则
          </div>
          <div class="line">
            (一) 共享
          </div>
          <div class="line">
            （1）共享原则
          </div>
          <div class="line">
            我们在遵守“合法正当、最小必要、目的明确原则”的前提下共享您的孩子个人信息，我们承诺只会共享必要的儿童个人信息。同时，我们将对儿童个人信息的共享活动事先进行个人信息保护影响评估，对输出形式、流转、使用等采取有效的技术保护措施。在合作协议层面，严格要求合作伙伴的信息保护义务与责任，与业务合作伙伴在合作前签署关于数据安全的保护协议。
          </div>
          <div class="line">
            （2）向第三方提供
          </div>
          <div class="line">
            除非存在以下一种或多种情形，我们不会向任何第三方提供儿童个人信息：
          </div>
          <div class="line">
            与作为监护人的您之间的共享；
          </div>
          <div class="line">
            事先已征得您的明确授权同意；
          </div>
          <div class="line">
            与四川繁羽开天科技有限公司公司内部的必要、合理共享。
          </div>
          <div class="line">
            <!-- 为便于我们基于四川繁羽开天科技有限公司统一的账号体系向您/您的孩子提供一致化服务、完善个性化体验、-->
            实现安全风控之需要，以及便于您进行统一管理，您知悉并同意，您的孩子的相关个人信息可能会在四川繁羽开天科技有限公司的产品内部进行必要共享；
          </div>
          <div class="line">
            为履行法定职责或者法定义务所必需，法律、行政法规规定的其他情形。
          </div>
          <div class="line">
            请您放心，除非取得您的单独同意，否则我们不会将您的孩子的个人信息向任何第三方提供用于营销活动。
          </div>
          <div class="line">
            （3）委托处理
          </div>
          <div class="line">
            若存在委托处理关系，我们将会与受托人约定委托处理的目的、期限、处理方式、个人信息的种类、保护措施以及双方的权利和义务等，并对受托人的个人
            信息处理活动进行监督，要求受托方：
          </div>
          <div class="line">
            （1）对您/您的孩子提出的权利响应需求及时向我们报告并协助反馈；
          </div>
          <div class="line">
            （2）采取严格措施保障儿童个人信息安全；
          </div>
          <div class="line">
            （3）不得未经允许转委托，且委托关系终止时，应当立刻删除或匿名化处理全部儿童个人信息；
          </div>
          <div class="line">
            （4）遵守其他法律法规要求的义务及与我们约定的义务。
          </div>
          <div class="line">
            (二) 转让
          </div>
          <div class="line">
            转让是指将个人信息控制权向其他公司、组织或个人转移的过程。原则上我们不会将您的孩子的个人信息转让，但以下情况除外：
          </div>
          <div class="line">
            您自行提出要求，且符合法律法规及监管的相关规定条件的；
          </div>
          <div class="line">
            如果我们因合并、分立、解散、被宣告破产的原因需要转移个人信息的，我们会向您告知接收方的名称或者姓名和联系方式，并要求接收方继续受本政策的约束。接收方变更原先的处理目的、处理方式的，我们将要求接收方重新取得您的同意
          </div>
          <div class="line">
            (三) 公开披露
          </div>
          <div class="line">
            除符合法律法规的规定进行公开披露或获得您单独同意外，我们不会公开披露您/您的孩子未自行公开或者其他未合法公开的个人信息。且在我们公开披露您/您的孩子的个人信息前会进行个人信息保护影响评估，并采用符合行业内标准的安全保护措施进行处理。
          </div>
          <div class="line">
            如您希望了解更多，请您查阅相关产品与/或服务独立隐私政策“我们如何共享、转让、公开披露您的个人信息”章节。
          </div>
          <div class="line">
            四. 对儿童个人信息的控制权
          </div>
          <div class="line">
            我们在我们的产品与/或服务中提供了多种对儿童个人信息行使控制权的功能，您可以通过这些功能管理儿童个人信息和儿童的网络生活，保障儿童个人信息安全。您/您的孩子可以按照相关产品与/或服务独立隐私政策“您对个人信息享有的控制权”章节指引进行操作。
          </div>
          <div class="line">
            五. 我们存储和保护儿童个人信息的规则
          </div>
          <div class="line">
            (一) 儿童个人信息的存储
          </div>
          <div class="line">
            1.存储地点：我们依照法律法规的规定，将儿童个人信息存储于中华人民共和国境内。
          </div>
          <div class="line">
            2.存储期限：除法律法规或监管部门另有规定外，我们仅在为提供我们的产品与/或服务之目的所必需且最短的期间内存储儿童个人信息。在超出上述存储期限后，我们会对儿童个人信息进行删除或匿名化处理。
          </div>
          <div class="line">
            (二) 儿童个人信息的保护措施
          </div>
          <div class="line">
            针对儿童个人信息，我们采用了符合行业标准的安全技术及组织和管理等保护措施以最大程度降低儿童的个人信息被泄露、毁损、误用、非授权访问、非授权披露和更改的风险。
          </div>
          <div class="line">
            严格控制儿童个人信息的访问权限，对可能接触到儿童个人信息的工作人员根据最小必要原则进行授权限制，并采取技术措施对工作人员处理儿童个人信息的行为进行记录和管控，避免违法复制、下载儿童个人信息。同时，定期对相关人员进行安全教育和培训。
          </div>
          <div class="line">
            我们制定儿童个人信息安全事件应急预案，组织内部相关人员进行应急响应培训和应急演练，使其掌握岗位职责和应急处置策略和规程。当发现儿童个人信息发生或者可能发生泄露、篡改、毁损、丢失的，我们会立即启动应急预案，采取补救措施。我们将按照法律法规的要求，及时向您/您的孩子告知：安全事件的基本情况和可能的影响、我们已采取或将要采取的处置措施、您/您的孩子可自主防范和降低风险、减轻危害的建议、我们的联系方式等。我们将及时将事件相关情况以App推送通知、发送邮件/短消息等方式告知您/您的孩子。难以逐一告知时，我们会采取合理、有效的方式发布相关警示信息。同时，我们还将按照监管部门要求，主动上报儿童个人信息安全事件的处置情况。若您/您的孩子的合法权益受损，我们将承担相应的法律责任。
          </div>
          <div class="line">
            如您希望了解更多，请您查阅相关产品与/或服务独立隐私政策“我们如何存储和保护您的个人信息”章节。

          </div>
          <div class="line">
            六. 本规则的更新
          </div>
          <div class="line">
            我们鼓励您在同意并监护、管理您的孩子使用我们的产品与/或服务前仔细查阅我们的《四川繁羽开天科技有限公司儿童个人信息保护规则》。我们会根据产品与/或服务的更新情况及法律法规的相关要求更新本规则的条款，该更新构成本规则的一部分。我们会通过站内信或其他适当的方式提醒您更新的内容，以便您及时了解本规则的最新版本。如该更新涉及重大变更，我们将在本规则生效前通过显著方式向您进行通知（如网站公示、弹窗方式）。但未经您明确同意，我们不会减损或侵害您/您的孩子依据本规则享有的个人权益。

          </div>
          <div class="line">
            七. 如何联系我们
          </div>
          <div class="line">
            如您对本规则的执行或您/您的孩子在使用我们的产品与/或服务时对儿童隐私保护相关的事宜有任何问题（包括问题咨询、投诉等），您可以通过luyou@fanyukaitian.com.cn与我们联系，我们有专门人员负责对接，并在验证您（监护人）与您的孩子的身份后的十五天内对您的问题进行反馈；您也可以通过相关产品与/或服务独立隐私政策“如何联系我们”章节中提供的其他反馈通道与我们联系，我们会尽最大努力为您提供满意的解决方案。
          </div>
        </div>


        <div class="section">
          <div class="boldT line">七、本政策的更新</div>
          <div class="line">
            <span class="boldT">我们鼓励您在使用我们的产品或服务前仔细查阅我们的《四川繁羽开天科技有限公司游戏隐私政策》</span>
            <span>。为了给您提供更好的服务，我们会根据产品的更新情况及法律法规的相关要求更新本政策的条款，该更新构成本政策的一部分。我们会通过站内信或其他适当的方式提醒您更新的内容，以便您及时了解本政策的最新版本。如该更新涉及重大变更，我们将在本政策生效前通过显著方式向您进行通知(如网站公示、弹窗方式)。但未经您明确同意，我们不会减损或侵害您依据本政策享有的个人权益。</span>
          </div>
        </div>

        <div class="section">
          <div class="boldT line">八、如何联系我们</div>
          <div class="line">(一)关于我们</div>
          <div class="line">我们的运营主体是四川繁羽开天科技有限公司传媒有限公司，基本情况如下</div>
          <div class="line">成立时间:2024年06月04日</div>
          <div class="line">
            注册地址/常用办公地址:中国(四川)自由贸易试验区成都高新区梓州大道6900号6楼633号
          </div>
          <div class="line">联系电话:15210416744</div>
          <div class="line">
            关联公司是指控制四川繁羽开天科技有限公司传媒有限公司、受四川繁羽开天科技有限公司传媒有限公司控制或与四川繁羽开天科技有限公司传媒有限公司处于共同控制下的公司、机构。控制指通过所有权、有投票权的股份、合同、实际运营关联或其他被依法认定的方式直接或间接地拥有影响被控制对象管理/经营的能力。
          </div>
          <div class="line">(二)联系我们</div>
          <div class="line">
            如您对本政策的执行或对我们的隐私保护相关事宜有任何投诉、建议、疑问，您可通过以下方式联系我们，我们会在验证您的用户身份后的15个工作日内向您回复:
          </div>
          <div class="line">
            1.专设的邮件通道:为更好地保护您的权益，我们专门设立了
            <a href="luyou@fanyukaitian.com.cn">luyou@fanyukaitian.com.cn</a>
            邮箱,您可以通过该邮箱与我们联系;
          </div>
          <div class="line">2.个人信息保护专员:
            您可发送邮件至
            <a href="luyou@fanyukaitian.com.cn">luyou@fanyukaitian.com.cn</a>
            或写信至以下地址来与其联系:中国(四川)自由贸易试验区成都高新区梓州大道6900号6楼633号
            法律部 个人信息保护专员(收);邮编:610000;
          </div>
          <div class="line">
            3.在线客服/其他在线意见反馈通道:您可与我们平台上产品功能页面的在线客服联系或者在线提交意见反馈;
          </div>
          <div class="line">4.人工客服通道:您可以拨打我们的任何一部客服电话与我们联系。</div>
          <div class="line">
            我们将在收到您的请求后并完成身份验证后15日内完成用户的处理响应，协助解决您的问题。为保障我们高效处理您的问题并及时向您反馈，我们可能会验证您的身份并要求您提供相关证据，我们会在验证用户的身份后处理您的请求。
          </div>
        </div>
        <div class="section">
          <div class="boldT line">九、其他</div>
          <div class="line">
            (一)本政策所称“四川繁羽开天科技有限公司游戏”，主要包括我们合法拥有、管理并运营的各类游戏客户端应用程序(包括但不限于PC端、移动端、小程序端等全部终端客户端)、官方网站及供第三方客户端应用程序及/或官方网站使用的网页、软件开发工具包(SDK)和应用程序编程接口(API)
          </div>
          <div class="line">
            (二)本政策适用于四川繁羽开天科技有限公司游戏产品与/或服务，但如其中的部分产品与/或服务(包括但不限于某项产品与或服务、某类型终端客户端)单独设置了隐私条款/隐私协议的，单独的隐私条款/隐私协议优先适用，单独的隐私条款/隐私协议未提及的内容，适用本政策。
          </div>
          <div class="line">
            请您注意，本政策不适用于以下情况:我们的产品与/或服务中包含的或链接至第三方提供的产品与/或服务(包括任何第三方客户端应用程序、网站及/或其他产品与/或服务)，这些产品与/或服务由第三方负责运营，您使用该产品与/或服务适用第三方另行向您说明的个人信息处理规则，除本政策外，在特定场景下，我们将以及时告知的方式(包括但不限于更新本政策、重新签署文件、页面提示、弹窗、站内信、邮件、网站公告或其他便于您获知的方式)另行向您详细说明对应信息的处理目的、方式、范围等规则，并在征得您的授权同意后处理(如适用)。
          </div>
          <div class="boldT line">
            (三)本政策的解释及争议解决均应适用中华人民共和国大陆地区法律。如就本政策的签订、履行等发生任何争议的，双方应尽量友好协商解决:协商不成时，任何一方均可向成都市高新区人民法院提起诉讼。
          </div>
          <div class="line">(四)本政策的标题仅为方便及阅读而设，不影响本协议任何条款的含义或解释。</div>
        </div>
        <div class="section">
          <div class="line">四川繁羽开天科技有限公司</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "yh",
  data(){
    return {
      isM: false
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      // 确保组件实例创建后再执行 scrollTo
      vm.$nextTick(() => {
        window.scrollTo(0, 0);
      });
    });
  },
  beforeDestroy() {
    window.scrollTo(0, 0);
    this.isM = false;
  },
  activated() {
    this.isM = window.innerWidth <= 750
  },
  created() {
    this.isM = window.innerWidth <= 750
  },
  methods: {
    getPic() {
      return this.isM ? require(`imgM/ys_bg.jpg`) : require(`img/ys_bg.jpg`);
    }
  }
}
</script>

<style scoped lang="less">

.content-box{
  font-size: .24rem;
  color: #2c3e50;

  .content{
    position: absolute;
    left: 0;
    top: 0;
    box-sizing: border-box;
    width: 100%;
    z-index: 1;
    padding: 1rem 3rem;
    text-align: left;
    font-size: .24rem;
    line-height: .32rem;

    .head{
      font-size: .4rem;
      font-weight: bold;
      text-align: center;
      margin-bottom: 1rem;
      font-size: .24rem;
    }
    .section{
      margin-bottom: .6rem;
      .boldT{
        font-weight: bold;
        font-size: .24rem;
      }
      .line{
        margin-bottom: .16rem;
        font-size: .24rem;
      }
      span{
        font-size: .24rem;
      }
      a{
        font-size: .24rem;
      }
    }
  }
}

.content-box.m{
  font-size: .24rem;
  color: #2c3e50;

  .content{
    position: absolute;
    left: 0;
    top: 0;
    box-sizing: border-box;
    width: 100%;
    z-index: 1;
    padding: .4rem .3rem;
    text-align: left;
    font-size: .24rem;
    line-height: .32rem;

    .head{
      font-size: .4rem;
      font-weight: bold;
      text-align: center;
      margin-bottom: 1rem;
      font-size: .24rem;
      line-height: .5rem;
    }
    .section{
      margin-bottom: .4rem;
      .boldT{
        font-weight: bold;
        font-size: .24rem;
      }
      .line{
        margin-bottom: .16rem;
        font-size: .24rem;
      }
      span{
        font-size: .24rem;
      }
      a{
        font-size: .24rem;
      }
    }
  }
}

</style>


// WEBPACK FOOTER //
// src/views/ys.vue